import React, { Component } from 'react';
import Page from '../components/Page';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Segment, Header, Icon, Dropdown, Popup, Form, Modal } from 'semantic-ui-react';
import {
	Box,
	Button,
	Stack,
	Paper,
	Table,
	TableBody,
	TableRow,
	TableHead,
	TableCell,
	Card,
	CardContent,
	Typography,
	Divider,
	TableContainer,
	Radio,
	RadioGroup,
	FormControlLabel,
	TextField,
	FormControl,
	CircularProgress,
	CardHeader,
	List,
	ListItem,
	ListItemText,
	ListItemIcon,
	CardActions,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { post, toWapi } from '../util/api';
import { load_product } from '../actions/product.actions';
import moment from 'moment';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import CircleIcon from '@mui/icons-material/Circle';
import CheckIcon from '@mui/icons-material/Check';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import TimelineIcon from '@mui/icons-material/Timeline';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import Countries from './settings/countries.json';
import { Link } from 'react-router-dom';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import * as GA from '../util/GA';
import IntlTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/main.css';
const LIVE_PLAN_ID = process.env.REACT_APP_LIVE_PLAN_ID;
const API_PLAN_ID = process.env.REACT_APP_API_PLAN_ID;
const MULTI_API_PLAN_ID = process.env.REACT_APP_MULTI_API_PLAN_ID;
const AGENT_PLAN_ID = process.env.REACT_APP_AGENT_PLAN_ID;
const PHONE_PLAN_ID = process.env.REACT_APP_PHONE_PLAN_ID;
const MULTI_PHONE_PLAN_ID = process.env.REACT_APP_MULTI_PHONE_PLAN_ID;
const HISTORY_DATA_ID = process.env.REACT_APP_HISTORY_DATA_ID;
const INSTAGRAM_PLAN_ID = process.env.REACT_APP_INSTAGRAM_PLAN_ID;
const LIVEAPI_PLAN_ID = process.env.REACT_APP_LIVEAPI_PLAN_ID;
const NEW_PHONE_PLAN_ID = process.env.REACT_APP_PHONE_NEW_PLAN_ID;
const PHONE_19_PLAN_ID = process.env.REACT_APP_PHONE_19_PLAN_ID;
const PHONE_15_PLAN_ID = process.env.REACT_APP_PHONE_15_PLAN_ID;
const PHONE_9_PLAN_ID = process.env.REACT_APP_PHONE_9_PLAN_ID;
const API_PLAN_ID_ANNUALLY = process.env.REACT_APP_YEARLY_API;
const PHONE_PLAN_ID_ANNUALLY = process.env.REACT_APP_YEARLY_PHONE;
const PHONE_PLAN_ID_SIXMONTH = process.env.REACT_APP_SIXMONTH_PHONE;
const options = [];
for (var i = 1; i <= 300; i++) {
	options.push({ key: '' + i, text: '' + i, value: i });
}

const Item = styled(Paper)(({ theme }) => ({
	backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fafafa',
	...theme.typography.body2,
	padding: theme.spacing(1),
	textAlign: 'center',
	color: theme.palette.text.secondary,
}));

const Questions = [
	{ title: 'Does not meet my needs', state: 'feedback_need', textbox: true, textboxText: 'What is your needs?' },
	{ title: 'Technical issues', state: 'feedback_technical', textbox: true, textboxText: 'What is the technical problem?' },
	{ title: 'Banned', state: 'feedback_banned', textbox: true, textboxText: "Anything you'd like to share?" },
	{ title: 'Too expensive', state: 'feedback_expensive', textbox: true, textboxText: "Anything you'd like to share?" },
	{ title: 'Switching to another provider', state: 'feedback_provider', textbox: true, textboxText: 'Which will you use other provider?' },
	{ title: 'Not enough support from MAYTAPI team', state: 'feedback_team', textbox: true, textboxText: "Anything you'd like to share?" },
	{ title: 'I will buy again', state: 'feedback_iwill_buy_later', textbox: true, textboxText: "Anything you'd like to share?" },
	{ title: 'Other', state: 'feedback_other', textbox: true, textboxText: "Anything you'd like to share?" },
];

class Payment extends Component {
	state = {
		loading: false,
		update: false,
		open: false,
		openNew: false,
		openCreate: false,
		openPopup: false,
		openChangePopup: false,
		previewModal: false,
		unsubscribe: false,
		messageOnScreen: null,
		messageColor: 'yellow',
		unsubscribeTrial: false,
		feedbackText: '',
		feedbackOption: '',
		packageName: '',
		feedbackTitle: '',
		disableSubButton: true,
		disableSubCancelButton: false,
		loadSubButton: false,
		plan_id: '',
		subscription_id: '',
		user_id: '',
		quantity_id: '',
		buyWait: false,
		crPhoneQu: 1,
		crAgentQu: 1,
		quantityUpdate: 1,
		quantity: _.get(this.props, 'product.settings.phone_limit') || 1,
		quantityAgent: _.get(this.props, 'product.settings.agent_limit') || 1,
		options,
		plans: this.props.product.settings.subscription_package || 'api',
		trialButtonLoading: false,
		trialButtonLoadingApi: false,
		trialButtonLoadingLive: false,
		trialButtonLoadingInstagram: false,
		trialSuccess: false,
		billDate: '',
		planChangeModal: false,
		purchaseModal: false,
		companyName: (this.props.user.extra && this.props.user.extra.company && this.props.user.extra.company.name) || '',
		vatNumber: (this.props.user.extra && this.props.user.extra.company && this.props.user.extra.company.vatNumber) || '',
		companyCountry: (this.props.user.extra && this.props.user.extra.company && this.props.user.extra.company.country) || '',
		companyCity: (this.props.user.extra && this.props.user.extra.company && this.props.user.extra.company.city) || '',
		companyState: (this.props.user.extra && this.props.user.extra.company && this.props.user.extra.company.state) || '',
		companyPostCode: (this.props.user.extra && this.props.user.extra.company && this.props.user.extra.company.postcode) || '',
		companyStreet: (this.props.user.extra && this.props.user.extra.company && this.props.user.extra.company.street) || '',
		isVat: false,
		select_date: new Date(),
		historyData: false,
		openPopup19: false,
		openPopup19Update: false,
		phoneTextModal: (this.props.user.extra && this.props.user.extra.company && this.props.user.extra.company.phonenumber) || '',
		convertPhoneNumber: (this.props.user.extra && this.props.user.extra.company && this.props.user.extra.company.phonenumber) || '',
		phoneTextModalStatus: false,

		purschaseTextModal: (this.props.user.extra && this.props.user.extra.company && this.props.user.extra.company.phonenumber) || '',
		convertPurschaseNumber: (this.props.user.extra && this.props.user.extra.company && this.props.user.extra.company.phonenumber) || '',
		purschasephoneTextModalStatus: false,

		disabledPhonesModal: false,
		disabledPhonesCount: 0,
		restartModal: false,
		restartSubscriptionData: null,
	};

	componentDidMount() {
		this.setupPaddleMessageListener();
		//this.checkForDisabledPhones();
	}

	setupPaddleMessageListener() {
		// Global event listener ekle
		window.addEventListener('message', this.handlePaddleMessage);
	}

	componentWillUnmount() {
		window.removeEventListener('message', this.handlePaddleMessage);
	}

	checkForDisabledPhones = async () => {
		try {
			const result = await toWapi(`/api/${this.props.product.id}/listPhones`, this.props.product.settings.wapi_token);

			if (result.status === 200) {
				const disabledPhones = result.data.filter((phone) => phone.status === 'disabled' && phone.type === 'whatsapp');

				if (disabledPhones.length > 0) {
					// Show modal with English messages
					this.setState({
						disabledPhonesModal: true,
						disabledPhonesCount: disabledPhones.length,
					});
				}
			}
		} catch (error) {
			console.error('Error checking disabled phones:', error);
		}
	};

	handlePaddleMessage = (event) => {
		// Paddle'dan gelen mesajları kontrol et
		console.log('--------', event);
		if (event && event.data && event.data.callback_data && event.data.callback_data.error) {
			//console.log('Paddle iframe event:', event.data);

			// Hata mesajlarını kontrol et

			// Hata yakalandı
			const errorMessage = event.data.callback_data.error;

			this.setState({
				messageOnScreen: errorMessage,
				messageColor: 'red',
			});

			// Hatayı loglayın
			post('/footprint/add', {
				category: 'maytapi',
				label: 'paddle-payment-declined',
				extra: {
					pid: this.props.product.id,
					uid: this.props.access.user.loggedUserObj.id,
					checkout: event.data.callback_data.checkout,
					user: event.data.callback_data.user,
					error: event.data.callback_data.error,
				},
			});
		}
	};
	refresh() {
		setTimeout(() => {
			this.props.dispatch(load_product('maytapi'));
		}, 1000);
	}
	getPhoneIds = async () => {
		try {
			const result = await toWapi(`/api/${this.props.product.id}/listPhones`, this.props.product.settings.wapi_token);

			if (result.status === 200) {
				const phones = result.data.filter((phone) => phone.type === 'whatsapp');
				const phoneOptions = phones.map((phone) => ({
					key: phone.id,
					text: `Phone ${phone.id} (${phone.status})`,
					value: phone.id,
				}));
				this.setState({ phoneOptions });
			}
		} catch (error) {
			console.error('Error fetching phones:', error);
		}
	};
	handlePhoneSelection = (e, { value }) => {
		const { quantityUpdate, selectedOldQuantity } = this.state;
		const isIncrease = quantityUpdate > selectedOldQuantity;
		const requiredSelections = isIncrease ? quantityUpdate - selectedOldQuantity : selectedOldQuantity - quantityUpdate;

		// Only allow selection up to required number of phones
		if (value.length <= requiredSelections) {
			this.setState({ selectedPhoneIds: value });
		}
	};
	openModal = (value) => {
		console.log('value', value);
		this.setState({
			selectedSubs: value.selectedSubs,
			selectedCurQu: value.currentQuantity,
			open: true,
			selectedUserid: value.user_id,
			selectedPlanid: value.plan_id,
			amountPrice: value.price,
			selectedOldQuantity: value.old_quantity,
		});
		if (this.props.product.settings.update_limited) {
			this.setState({ quantityUpdate: parseInt(value.old_quantity) });
		}
	};
	openUnSubsTrialModal = () => () => {
		this.setState({
			unsubscribeTrial: true,
		});
	};
	openPop = (value) => {
		console.log('here', value);
		this.setState({ [value]: true });
		setTimeout(() => {
			this.setState({ [value]: false });
		}, 3000);
	};

	openNewModal = (value) => () => {
		console.log('value', value);
		this.setState({
			selectedSubs: value.selectedSubs,
			selectedCurQu: value.currentQuantity,
			openNew: true,
			selectedUserid: value.user_id,
			selectedPlanid: value.plan_id,
			amountPrice: value.price,
			historyData: value.historyData,
			selectedOldQuantity: value.old_quantity,
		});
	};

	openRestartModal = (subscriptionData) => {
		this.setState({
			restartModal: true,
			restartSubscriptionData: subscriptionData,
		});
	};

	openCreateModal = (value) => () => {
		this.setState({ openCreate: true, amountPrice: value.price });
	};
	/* createTrial = (value) => () => {
		this.setState({ buyWait: true });
	}; */
	closeWaitModal = () => () => {
		this.setState({ buyWait: false });
	};
	openSubsModal = (value) => () => {
		this.setState({
			selectedPlanid: value.plan_id,
			selectedUserid: value.user_id,
			selectedQuantity: value.quantity,
			selectedSubs: value.subscription_id,
		});
	};
	closeModal = () => {
		this.setState({
			open: false,
			unsubscribe: false,
			openCreate: false,
			openNew: false,
			unsubscribeTrial: false,
			trialSuccess: false,
			planChangeModal: false,
			previewModal: false,
			purchaseModal: false,
			historyModal: false,
			trialChangeModal: false,
			helpModal: false,
			restartModal: false,
		});
	};

	closeOne = () => {
		this.setState({
			unsubscribe: false,
			unsubscribeTrial: false,
		});
	};

	closeTrialModal = () => {
		this.refresh();
	};
	closeUpdate = () => {
		this.setState({ update: false });
	};
	createTrial = (value) => async () => {
		this.setState({
			trialButtonLoadingLive: value.loadingLive,
			trialButtonLoadingApi: value.loadingApi,
			trialButtonLoadingInstagram: value.loadingInstagram,
			trialButtonLoadingMultiApi: value.loadingMultiApi,
		});
		await post('/maytapi/createFreeTrial', { pid: value.pid, type: value.plan }).then((data) => {
			if (data.data.success) {
				this.setState({ trialSuccess: true, messageOnScreen: data.data.message, trialPlan: value.plan });
				post('/footprint/add', {
					category: 'maytapi',
					label: 'checkout-start',
					extra: {
						pid: value.id,
						uid: this.props.access.user.loggedUserObj.id,
						plan: 'trial',
					},
				});
				this.checkForDisabledPhones();
			} else {
				this.refresh();
				this.setState({ messageOnScreen: data.data.message });
			}
		});
	};
	changeTrial = (value) => async () => {
		this.setState({
			changeTrialButtonLoading: true,
		});
		let type = value.plan === 'maytapi-trial-api' ? 'maytapi-trial-live' : 'maytapi-trial-api';
		await post('/maytapi/changetrial', { pid: this.props.product.id, type }).then((data) => {
			if (data.data.success) {
				this.setState({ messageOnScreen: 'Your trial subscription type change.', changeTrialButtonLoading: false });
				this.refresh();
			} else {
				this.setState({ messageOnScreen: 'Error', changeTrialButtonLoading: false });
			}
		});
	};

	sendFeedback = () => async () => {
		this.setState({ loadSubButton: true, disableSubButton: true, disableSubCancelButton: true });
		let { feedbackTitle, feedbackOption, feedbackText, packageName, convertPhoneNumber } = this.state;
		let { user, product } = this.props;
		let { id, extra } = user;
		let pid = product.id;
		let plan_id;
		this.updatePhone({
			phone: this.state.convertPhoneNumber,
		});
		this.postData({
			companyName: this.state.companyName,
			vatNumber: this.state.vatNumber,
			country: this.state.companyCountry,
			city: this.state.companyCity,
			state: this.state.companyState,
			street: this.state.companyStreet,
			postcode: this.state.companyPostCode,
			phonenumber: this.state.convertPhoneNumber,
		});
		if (packageName === 'trial') {
			plan_id = 'trial';
			this.setState({ trialButtonLoading: true });
			await post('/maytapi/deleteFreeTrial', {
				pid: this.props.product.id,
			}).then((data) => {
				!data.data.success ? this.setState({ openUnSubsTrialModal: false, message: 'error' }) : this.refresh();
			});
		} else {
			plan_id = this.state.plan_id;
			if (extra && extra.cancel2) {
				post('/maytapi/cancelSubscription2', {
					pid: this.props.product.id,
					subscription_id: this.state.subscription_id,
					plan_id: this.state.plan_id,
					user_id: this.state.user_id,
					quantity: this.state.quantity_id,
				}).then(() => {
					this.refresh();
					this.setState({ messageOnScreen: 'Unsubscription is successful!', messageColor: 'green' });
				});
			} else
				post('/maytapi/cancelSubscription', {
					pid: this.props.product.id,
					subscription_id: this.state.subscription_id,
					plan_id: this.state.plan_id,
					user_id: this.state.user_id,
					quantity: this.state.quantity_id,
					//iptal mesajı için
					feedbackOption: this.state.feedbackOption,
					feedbackText: this.state.feedbackText.trim(),
					phoneNumber: this.state.convertPhoneNumber,
					subscriptionType: this.state.subscriptionType,
					email: this.props.user.email,
				}).then(() => {
					this.refresh();
					this.setState({ messageOnScreen: 'Unsubscription is successful!', messageColor: 'green' });
				});
		}

		post('/footprint/add', {
			category: 'maytapi',
			label: 'feedback',
			extra: {
				package: plan_id,
				pid,
				uid: id,
				feedback_id: feedbackOption,
				feedback_text: feedbackText.trim(),
				feedback_title: feedbackTitle,
				feedback_phone_number: convertPhoneNumber,
			},
		});

		this.closeModal();
	};

	deleteTrial = () => async () => {
		this.setState({ trialButtonLoading: true });
		await post('/maytapi/deleteFreeTrial', {
			pid: this.props.product.id,
		}).then((data) => {
			!data.data.success ? this.setState({ openUnSubsTrialModal: false, message: 'error' }) : this.refresh();
		});
	};
	postData(values) {
		let extra = _.merge(this.props.user.extra, {
			company: {
				name: values.companyName,
				vatNumber: values.vatNumber,
				country: values.country,
				state: values.state,
				city: values.city,
				street: values.street,
				postcode: values.postcode,
				phonenumber: values.phonenumber,
			},
		});
		post('/auth/updateInfo', {
			id: this.props.user.id,
			company: values.companyName,
			extra,
		});
	}
	updatePhone(values) {
		post('/auth/updatePhone', {
			id: this.props.user.id,
			phone: values.phone,
		});
	}
	checkoutHandler = (quantity, plan, isVat) => async () => {
		this.updatePhone({
			phone: this.state.convertPurschaseNumber,
		});
		this.postData({
			companyName: this.state.companyName,
			vatNumber: this.state.vatNumber,
			country: this.state.companyCountry,
			city: this.state.companyCity,
			state: this.state.companyState,
			street: this.state.companyStreet,
			postcode: this.state.companyPostCode,
			phonenumber: this.state.convertPurschaseNumber,
		});
		let link = await post('/maytapi/custompaddlelink', {
			plan_id: plan,
			isVat,
			pid: this.props.product.id,
			vat_number: this.state.vatNumber,
			vat_company_name: this.state.companyName,
			vat_street: this.state.companyStreet,
			vat_city: this.state.companyCity,
			vat_country: this.state.companyCountry,
			country: isVat ? this.state.companyCountry : 'BR',
			postcode: this.state.companyPostCode,
			vat_state: this.state.companyState,
			vat_postcode: this.state.companyPostCode,
			email: this.props.access.user.loggedUserObj.email,
			date: this.state.select_date,
		});
		try {
			this.closeModal();
			let { product = {} } = this.props;
			//let response = await get('/maytapi/product').then(this.setState({ loading: false }));
			let subscriptions = product.activeSubs;
			let email = this.props.access.user.loggedUserObj.email;
			for (let i = 0; i < subscriptions.length; i++) {
				let planId = subscriptions[i].data.subscription_plan_id;
				if (planId === `${LIVE_PLAN_ID}` || planId === `${API_PLAN_ID}` || planId === `${MULTI_API_PLAN_ID}`) {
					email = subscriptions[i].data.email;
				}
			}
			post('/footprint/add', {
				category: 'maytapi',
				label: 'checkout-start',
				extra: {
					pid: product.id,
					uid: this.props.access.user.loggedUserObj.id,
					plan,
				},
			});
			if (product && product.id) {
				window.Paddle.Checkout.open({
					override: link.data.response.url,
					email,
					country: isVat ? this.state.companyCountry : 'BR',
					postcode: this.state.companyPostCode,
					successCallback: (data) => {
						post('/maytapi/checkSubscription', {
							checkout_id: data.checkout.id,
							plan_id: data.product.id,
							user_id: data.user.id,
							pid: this.props.product.id,
							quantity: data.product.quantity,
							email: data.user.email,
							extra: data,
						})
							.then((resp) => {
								if (resp.data.success) {
									GA.event({ action: 'subscription', category: 'analyze', label: 'Subscription', value: 1 });
									this.refresh();
									this.setState({ messageOnScreen: 'Process is successful!', messageColor: 'green' });
									this.checkForDisabledPhones();
								} else {
									this.setState({
										messageOnScreen: (resp.data.message && resp.data.message.message) || resp.data.message,
										messageColor: 'red',
									});
								}
							})
							.catch((err) => {
								console.error(err);
							});
						post('/footprint/add', {
							category: 'maytapi',
							label: 'checkout-success',
							extra: {
								pid: product.id,
								uid: this.props.access.user.loggedUserObj.id,
								checkout: data.checkout,
								subscription_plan: data.product,
							},
						});
					},
					closeCallback: (data) => {
						console.log('Checkout closed', data);
						post('/footprint/add', {
							category: 'maytapi',
							label: 'checkout-close',
							extra: {
								pid: product.id,
								uid: this.props.access.user.loggedUserObj.id,
								email: this.props.access.user.loggedUserObj.email,
								checkout: data.checkout,
								paddle_user: data.user,
								subscription_plan: data.product,
							},
						});
						this.setState({ messageOnScreen: 'Your process has been cancelled, see you again soon!', messageColor: 'red' });
					},
				});
			}
		} catch (err) {
			console.error(err);
		}
	};
	openPurchaseModal = (value, price, historyData) => {
		this.setState({ purchaseModal: true, selectedPlanId: value, purchasePrice: price, historyData });
	};
	openUpdSubsModal = async () => {
		this.setState({ open: true });
	};
	updateAfterAmuntEntered = (value) => async () => {
		const { selectedPhoneIds, quantityUpdate, selectedOldQuantity, previewdata } = this.state;
		const isIncrease = quantityUpdate > selectedOldQuantity;
		let planId = parseInt(value.plan_id, 10);
		let agentPlan = parseInt(AGENT_PLAN_ID, 10);
		let phonePlan = parseInt(PHONE_PLAN_ID, 10);
		let multiPhonePlan = parseInt(MULTI_PHONE_PLAN_ID, 10);
		let instagramPlan = parseInt(PHONE_PLAN_ID, 10);
		let next_payment_amount = this.state.previewdata.next_payment && this.state.previewdata.next_payment.amount;
		if (planId === agentPlan) {
			let result = await post('/maytapi/agent/list', { pid: this.props.product.id });
			if (result.status !== 200 || !result.data.success) {
				this.setState({ messageOnScreen: 'Update process is not successful!', messageColor: 'red' });
				this.closeModal();
			} else if (result.data.agents.length > value.quantity) {
				this.setState({
					messageOnScreen:
						'Current number of registered agent are more than the new amount you set. Please delete some agents before updating the agent limit!',
					messageColor: 'red',
				});
				this.closeModal();
			}
		} else if (planId === phonePlan) {
			let result = await toWapi(`/api/${this.props.product.id}/listPhones`, this.props.product.settings.wapi_token);
			let active_phones = _.filter(result && result.data, function (it) {
				return it.status !== 'disabled' && it.type === 'whatsapp';
			});
			//console.log(active_phones.length - 1 > value.quantity, active_phones);
			if (result.status !== 200) {
				this.setState({ messageOnScreen: 'Update process is not successful!', messageColor: 'red' });
				this.closeModal();
				return;
			} /* else if (active_phones.length - 1 > value.quantity) {
				//	console.log('active_phones.length - 1 > value.quantity', active_phones.length - 1, value.quantity);
				this.setState({
					messageOnScreen:
						'Current number of registered phones are more than the new amount you set. Please disable some phones before updating the phone limit!',
					messageColor: 'red',
				});
				this.closeModal();
				return;
			} */
		} else if (planId === multiPhonePlan) {
			let result = await toWapi(`/api/${this.props.product.id}/listPhones`, this.props.product.settings.wapi_token);
			let active_phones = _.filter(result && result.data, function (it) {
				return it.status !== 'disabled' && it.type === 'whatsapp';
			});
			//console.log(active_phones.length - 1 > value.quantity, active_phones);
			if (result.status !== 200) {
				this.setState({ messageOnScreen: 'Update process is not successful!', messageColor: 'red' });
				this.closeModal();
				return;
			} else if (active_phones.length - 1 > value.quantity) {
				this.setState({
					messageOnScreen:
						'Current number of registered phones are more than the new amount you set. Please disable some phones before updating the phone limit!',
					messageColor: 'red',
				});
				this.closeModal();
				return;
			}
		} else if (planId === instagramPlan) {
			let result = await toWapi(`/api/${this.props.product.id}/listPhones`, this.props.product.settings.wapi_token);
			let active_phones = _.filter(result && result.data, function (it) {
				return it.status !== 'disabled' && it.type === 'instagram';
			});
			//console.log(active_phones.length - 1 > value.quantity, active_phones);
			if (result.status !== 200) {
				this.setState({ messageOnScreen: 'Update process is not successful!', messageColor: 'red' });
				this.closeModal();
				return;
			} else if (active_phones.length - 1 > value.quantity) {
				this.setState({
					messageOnScreen:
						'Current number of registered instagram are more than the new amount you set. Please disable some instagram before updating the intagram limit!',
					messageColor: 'red',
				});
				this.closeModal();
				return;
			}
		}
		post('/maytapi/updateSubscription', {
			quantity: value.quantity,
			pid: this.props.product.id,
			subscription_id: value.subscription_id,
			old_quantity: value.old_quantity,
			plan_id: value.plan_id,
			user_id: value.user_id,
			phone_ids: selectedPhoneIds,
			is_increase: isIncrease,
			next_payment_amount,
		}).then((data) => {
			if (data.data.success) {
				this.refresh();
				this.setState({ messageOnScreen: 'Update process is successful!', messageColor: 'green', selectedPhoneIds: [] });
				this.checkForDisabledPhones();
			} else {
				this.setState({ messageOnScreen: data.data.message.message, messageColor: 'red', selectedPhoneIds: [] });
			}
		});
		this.closeModal();
	};

	updatePayment = (value) => async () => {
		let data = await post('/maytapi/getsubsdetails', { pid: this.props.product.id, subscription_id: value.subscription_id });
		let update_url = data.data && data.data.response && data.data.response[0].update_url;
		window.Paddle.Checkout.open({
			override: update_url,
			passthrough: {
				pid: this.props.product.id,
			},
		});
	};
	clickUnSubs = (value) => async () => {
		post('/maytapi/cancelSubscription', {
			pid: this.props.product.id,
			subscription_id: value.subscription_id,
			plan_id: value.plan_id,
			user_id: value.user_id,
			quantity: value.quantity,
		}).then(() => {
			this.refresh();
			this.setState({ messageOnScreen: 'Unsubscription is successful!', messageColor: 'green' });
		});
		this.closeModal();
	};
	getPaymentHistory = (value) => async () => {
		await post('/maytapi/getPaymentHistory', { subscription_id: value.subscription_id, pid: this.state.pid }).then((data) => {
			this.setState({ paymentHistory: _.orderBy(data.data.response, 'id', 'desc'), historyModal: true });
		});
	};

	reActiveSub = (value) => async () => {
		this.setState({ loadSubButton: true });
		await post('/maytapi/reactiveSubscription', {
			subscription_id: value.subscription_id,
			pid: this.props.product.id,
		})
			.then((response) => {
				if (response.data.success) {
					this.refresh();
					this.setState({
						messageOnScreen: 'Subscription reactivated successfully!',
						messageColor: 'green',
						loadSubButton: false,
					});
				} else {
					this.setState({
						messageOnScreen: response.data.message || 'Failed to reactivate subscription',
						messageColor: 'red',
						loadSubButton: false,
					});
				}
			})
			.catch((error) => {
				this.setState({
					messageOnScreen: 'An error occurred while reactivating subscription',
					messageColor: 'red',
					loadSubButton: false,
				});
			});
		this.closeModal();
	};

	handleAddition = (e, { value }) => {
		this.setState((prevState) => ({
			options: [{ text: value, value }, ...prevState.options],
		}));
	};
	handleChange = (e, { value }) => this.setState({ quantity: value });
	handleChangeFeedback = (e) => {
		this.setState({ [e.target.name]: e.target.value });
	};
	handleChangeModalPhoneNumber = (e) => [this.setState({ [e.target.name]: e.target.value })];
	handleChangePurschasePhoneNumber = (e) => [this.setState({ [e.target.name]: e.target.value })];
	openTextInFeedback = (e) => {
		let result = _.find(Questions, (a) => {
			if (e.target.value === a.state) {
				return a;
			}
		});
		if (result) {
			this.setState({ feedbackTitle: result.textboxText });
		} else {
			this.setState({ feedbackTitle: '' });
		}
		this.setState({ feedbackOption: e.target.value, disableSubButton: false });
	};

	handleChangeCrPhoneQu = (e, { value }) => this.setState({ crPhoneQu: value });
	handleChangeCrAgentQu = (e, { value }) => this.setState({ crAgentQu: value });
	handleChangeAgent = (e, { value }) => this.setState({ quantityAgent: value });
	handleChangeUpdate = (e, { value }) => this.setState({ quantityUpdate: value });

	openChangePlanModal = (plan_id, subscription_id) => async () => {
		let planId = plan_id === API_PLAN_ID ? LIVE_PLAN_ID : API_PLAN_ID;
		await post('/maytapi/checkpreview', {
			subscription_id,
			plan_id: planId,
		}).then((data) => {
			if (data.data.success) {
				this.setState({ previewdata: data.data.response, planChangeModal: true, selectedChange: planId, selectedSubcriptionId: subscription_id });
			} else {
				this.setState({ messageOnScreen: data.data.message.message, messageColor: 'red' });
			}
		});
	};
	openChangePlanModalDouble = (plan_id, subscription_id) => async () => {
		let planId = LIVEAPI_PLAN_ID;
		await post('/maytapi/checkpreview', {
			subscription_id,
			plan_id: planId,
		}).then((data) => {
			if (data.data.success) {
				this.setState({ previewdata: data.data.response, planChangeModal: true, selectedChange: planId, selectedSubcriptionId: subscription_id });
			} else {
				this.setState({ messageOnScreen: data.data.message.message, messageColor: 'red' });
			}
		});
	};
	openTrialChangeModal = (value) => async () => {
		this.setState({ trialChangeModal: true, trialChangePlan: value.plan });
	};

	openPreviewModal = (value) => async () => {
		let quantity = this.state.quantityUpdate;
		let selectedOldQuantity = this.state.selectedOldQuantity;
		if (value.add) {
			quantity = quantity + parseInt(this.state.selectedCurQu);
		}
		await this.getPhoneIds();
		await post('/maytapi/checkpreview', {
			subscription_id: this.state.selectedSubs,
			quantity,
			selectedOldQuantity,
		}).then((data) => {
			if (data.data.success) {
				this.setState({ previewdata: data.data.response, previewModal: true, quantityUpdate: quantity, selectedPhoneIds: [] });
			} else {
				this.setState({ messageOnScreen: data.data.message.message, messageColor: 'red', open: false, openNew: false });
			}
		});
	};
	changePlanId = (plan_id, subscription_id, pid) => async () => {
		this.closeModal();
		await post('/maytapi/updateplanid', {
			subscription_id,
			plan_id,
			pid,
		}).then((data) => {
			if (data.data.success) {
				this.refresh();
				this.setState({ messageOnScreen: 'Update process is successful!', messageColor: 'green' });
			} else {
				this.setState({ messageOnScreen: 'Update process cannot be applied!', messageColor: 'red' });
			}
		});
	};
	dateChange = (selection) => {
		let select_date = moment(selection.startDate).startOf('day');
		let today = moment();
		let diff = today.diff(select_date, 'days');
		if (diff > 90) {
			this.setState({ select_date: today.add(-90), diff });
		} else {
			this.setState({ select_date, seleced_diff: diff });
		}
	};
	handleFormChange = (e, { name, value }) => this.setState({ [name]: value });
	PLANS = {
		API: `${API_PLAN_ID}`,
		MULTIAPI: `${MULTI_API_PLAN_ID}`,
		LIVE: `${LIVE_PLAN_ID}`,
		PHONE: `${PHONE_PLAN_ID}`,
		NEWPHONE: `${NEW_PHONE_PLAN_ID}`,
		NEWPHONE19: `${PHONE_19_PLAN_ID}`,
		NEWPHONE15: `${PHONE_15_PLAN_ID}`,
		NEWPHONE9: `${PHONE_9_PLAN_ID}`,
		MULTIPHONE: `${MULTI_PHONE_PLAN_ID}`,
		AGENT: `${AGENT_PLAN_ID}`,
		HISTORY: `${HISTORY_DATA_ID}`,
		INSTAGTAM: `${INSTAGRAM_PLAN_ID}`,
		LIVEAPI: `${LIVEAPI_PLAN_ID}`,
		APIANNUALLY: `${API_PLAN_ID_ANNUALLY}`,
		PHONESIXMONTHLY: `${PHONE_PLAN_ID_SIXMONTH}`,
		'TRIAL-API': 'maytapi-trial-api',
		'TRIAL-LIVE': 'maytapi-trial-live',
		'TRIAL-MULTIAPI': 'maytapi-trial-multi-api',
		[INSTAGRAM_PLAN_ID]: 'INSTAGRAM',
		[PHONE_PLAN_ID]: 'PHONE',
		[NEW_PHONE_PLAN_ID]: 'PHONE',
		[PHONE_19_PLAN_ID]: 'PHONE19',
		[PHONE_15_PLAN_ID]: 'PHONE15',
		[PHONE_9_PLAN_ID]: 'PHONE9',
		[MULTI_PHONE_PLAN_ID]: 'MULTIPHONE',
		[AGENT_PLAN_ID]: 'AGENT',
		[LIVE_PLAN_ID]: 'LIVE',
		[API_PLAN_ID]: 'API',
		[MULTI_API_PLAN_ID]: 'MULTIAPI',
		[HISTORY_DATA_ID]: 'HISTORY',
		[LIVEAPI_PLAN_ID]: 'LIVEAPI',
		[API_PLAN_ID_ANNUALLY]: 'APIANNUALLY',
		[PHONE_PLAN_ID_SIXMONTH]: 'PHONESIXMONTHLY',
		'maytapi-trial-live': 'TRIAL-LIVE',
		'maytapi-trial-api': 'TRIAL-API',
		'maytapi-trial-multi-api': 'TRIAL-MULTIAPI',
	};
	handleChangePhone = (value, status, countryData, number) => {
		this.setState((state) => ({
			...state,
			phoneTextModal: value,
			convertPhoneNumber: number.replace(/\+| /gm, ''),
			phoneTextModalStatus: status,
			number,
			countryData,
		}));
	};
	handleChangePurschaseModalPhone = (value, status, countryData, number) => {
		this.setState((state) => ({
			...state,
			purschaseTextModal: value,
			convertPurschaseNumber: number.replace(/\+| /gm, ''),
			purschasephoneTextModalStatus: status,
			number,
			countryData,
		}));
	};
	render() {
		if (this.state.loading)
			return (
				<Page title="Subscription" icon={<ShoppingCartIcon />}>
					<Page.Loader />
				</Page>
			);
		let {
			vatNumber,
			companyCity,
			companyCountry,
			companyName,
			companyPostCode,
			companyState,
			companyStreet,
			phoneTextModal,
			//phoneTextModalStatus,
			purschaseTextModal,
			//purschasephoneTextModalStatus,
		} = this.state;
		let products = this.props.product;
		let settings = products.settings;
		let orderList = _.filter(_.orderBy(products.activeSubs, ['id'], ['asc']), function (o) {
			return o.data.subscription_plan_id;
		});
		let deletedList = _.filter(_.orderBy(products.deletedSubs, ['id'], ['asc']), function (o) {
			return o.data.subscription_plan_id;
		});
		/* let historyPackegeList = _.filter(_.orderBy(products.activeSubs, ['id'], ['asc']), function (o) {
			return o.data.product_id;
		}); */
		let trial = products.trial;
		let f_trial = false;
		let trialEndDate = products.activeSubs[0] && moment(products.activeSubs[0].created_at).startOf('day').add('3', 'days');
		let diffDate = moment(trialEndDate).diff(moment().startOf('day'), 'days');
		const { quantityUpdate, crPhoneQu } = this.state;
		let phoneSubs =
			_.find(this.props.product.activeSubs, { data: { subscription_plan_id: `${NEW_PHONE_PLAN_ID}` } }) ||
			_.find(this.props.product.activeSubs, { data: { subscription_plan_id: `${PHONE_9_PLAN_ID}` } }) ||
			_.find(this.props.product.activeSubs, { data: { subscription_plan_id: `${PHONE_PLAN_ID}` } }) ||
			'';
		let phoneSubs19 = _.find(this.props.product.activeSubs, { data: { subscription_plan_id: `${PHONE_19_PLAN_ID}` } }) || '';
		let phoneSubs15 = _.find(this.props.product.activeSubs, { data: { subscription_plan_id: `${PHONE_15_PLAN_ID}` } }) || '';
		//let multiPhoneSubs = _.find(this.props.product.activeSubs, { data: { subscription_plan_id: `${MULTI_PHONE_PLAN_ID}` } }) || '';
		let agentSubs = _.find(this.props.product.activeSubs, { data: { subscription_plan_id: `${AGENT_PLAN_ID}` } }) || '';
		//let instagramSubs = _.find(this.props.product.activeSubs, { data: { subscription_plan_id: `${INSTAGRAM_PLAN_ID}` } }) || '';
		var trials = { 'maytapi-trial-api': 'API', 'maytapi-trial-live': 'LiveChat' };
		let subscription = products.settings && products.settings.subscription_package && trials[products.settings.subscription_package];
		let expiredTrialType =
			products.trial === false &&
			products.deletedSubs &&
			products.deletedSubs[0] &&
			products.deletedSubs[0].data.trialType &&
			trials[products.deletedSubs[0].data.trialType];
		let sub_status = {
			past_due: {
				color: 'error',
				text: 'Past Due',
			},
			active: {
				color: 'success',
				text: 'Active',
			},
			deleted: {
				color: 'text',
				text: 'Cancelled',
			},
			paused: {
				color: 'warning',
				text: 'Paused',
			},
			cancelled: {
				color: 'error',
				text: 'cancelled',
			},
			live: {
				color: 'success',
				text: 'Live',
			},
		};
		let account_phone = products.settings.phone9 ? PHONE_9_PLAN_ID : products.settings.phone25 ? NEW_PHONE_PLAN_ID : PHONE_PLAN_ID;
		let account_phone_annually = PHONE_PLAN_ID_ANNUALLY;
		//console.log('NEW_PHONE_PLAN_ID', NEW_PHONE_PLAN_ID);
		let account_phone_price = products.settings.phone9
			? 9
			: products.settings.phone25
			? 25
			: phoneSubs && phoneSubs.data && phoneSubs.data.unit_price
			? parseFloat(phoneSubs.data.unit_price)
			: 29.9;
		let account_phone_annually_price = 299;
		let account_phone_6monthly_price = 159;

		return (
			<Page title="Subscription" icon={<ShoppingCartIcon />}>
				<style
					dangerouslySetInnerHTML={{
						__html: `
						.ui.page.modals.dimmer{
							z-index:999999999999 ;
						}`,
					}}
				/>
				<Box sx={{ padding: '30px' }}>
					<Stack sx={{ margin: 'auto', padding: '0', boxShadow: 'rgb(0 0 0 / 15%) 0px 5px 15px 0px', borderRadius: '8px' }}>
						{trial === null ? (
							<div style={{ margin: 'auto' }}>
								<Box sx={{ maxWidth: 275, marginTop: '20px' }}>
									<Card variant="outlined">
										<CardContent>
											<Typography gutterBottom variant="h5" component="div">
												API Package
											</Typography>
										</CardContent>
										<Divider />
										<CardContent>
											<div style={{ maxHeight: '200px' }}>
												<div style={{ textAlign: 'center' }}>
													<span style={{ fontSize: '72px', lineHeight: '72px' }}>
														$29.9<span style={{ fontSize: '16px', color: '#A9A9A9' }}>/mo</span>
													</span>
												</div>

												<div style={{ listStyle: 'none' }}>
													<li>API Package Includes One Number.</li>
													<li>29.9$ for Every New Phones.</li>
												</div>
											</div>
										</CardContent>
										<Divider />
										<CardContent>
											<Button
												onClick={this.createTrial({ pid: this.props.product.id, plan: 'api', loadingApi: true })}
												color="success"
												fullWidth
												size="medium"
												variant="contained"
												loading={this.state.trialButtonLoadingApi}
											>
												Start 3 Days Free Trial
											</Button>
											<div style={{ textAlign: 'right' }}>
												<span
													onClick={() => this.openPurchaseModal(`${API_PLAN_ID}`, 29.9)}
													style={{
														fontSize: '11px',
														color: 'black',
														textDecorationLine: 'underline',
														background: 'white',
														padding: '0',
													}}
												>
													{'Purchase skip trial ->'}
												</span>
											</div>
										</CardContent>
									</Card>
								</Box>
							</div>
						) : trial === true ? (
							<div>
								<Box style={{ textAlign: 'center', color: 'red', paddingTop: '10px', paddingBottom: '10px' }}>
									<p>
										{'Your ' + subscription + ' trial will over'} {diffDate > 0 ? diffDate + ' days later.' : 'today'}
									</p>
								</Box>
								<Divider />
								<div style={{ textAlign: 'center', paddingTop: '10px', paddingBottom: '10px' }}>
									<h3>Trial Subscription</h3>
									<p>You can't increase phones or agents limit in Trial Subscripton.</p>
									<p>If you want more phones or agents, you have to purchase one Starter Subscripton.</p>
								</div>
								<div style={{ display: 'flex', marginBottom: '20px' }}>
									<div style={{ margin: 'auto', width: '100%', padding: '0 16px' }}>
										<Box
											sx={{
												display: 'flex',
												flexDirection: { xs: 'column', md: 'row' },
												gap: 2,
												justifyContent: 'center',
												marginY: 2,
												'& > .MuiCard-root': {
													width: { xs: '100%', md: '300px' },
													maxWidth: { xs: '100%', md: '350px' },
												},
											}}
										>
											<Card
												sx={{
													display: 'flex',
													flexDirection: 'column',
													boxShadow: '2px 2px 10px rgba(0, 0, 0, 0.2)',
													mb: { xs: 2, md: 0 },
												}}
											>
												<CardHeader
													title="Monthly Plan"
													titleTypography={{ variant: 'h6' }}
													avatar={<CalendarMonthIcon sx={{ color: 'white' }} />}
													sx={{
														bgcolor: '#14B8A6',
														color: 'white',
														py: 1,
														'& .MuiCardHeader-content': {
															padding: '4px 0',
														},
														textAlign: 'left',
													}}
												/>
												<CardContent sx={{ py: 1, px: 2, flexGrow: 1 }}>
													<List dense sx={{ py: 0 }}>
														<ListItem sx={{ py: 0.5 }}>
															<ListItemIcon sx={{ minWidth: 25 }}>
																<InfoIcon color="success" fontSize="small" />
															</ListItemIcon>
															<ListItemText primary="Monthly billing" />
														</ListItem>
														<ListItem sx={{ py: 0.5 }}>
															<ListItemIcon sx={{ minWidth: 25 }}>
																<InfoIcon color="success" fontSize="small" />
															</ListItemIcon>
															<ListItemText primary="Basic support" />
														</ListItem>
													</List>
												</CardContent>
												<CardActions
													sx={{
														p: 1.5,
														display: 'flex',
														justifyContent: 'center',
													}}
												>
													<Button
														color="success"
														fullWidth
														size="medium"
														variant="contained"
														onClick={() => this.openPurchaseModal(`${PHONE_PLAN_ID}`, 29.9)}
													>
														Purchase $29.9 / month
													</Button>
												</CardActions>
											</Card>

											<Card
												sx={{
													display: 'flex',
													flexDirection: 'column',
													boxShadow: '2px 2px 10px rgba(0, 0, 0, 0.2)',
													mb: { xs: 2, md: 0 },
												}}
											>
												<CardHeader
													title="6 Month Plan"
													titleTypography={{ variant: 'h6' }}
													avatar={<CalendarMonthIcon sx={{ color: 'white' }} />}
													sx={{
														bgcolor: '#14B8A6',
														color: 'white',
														py: 1,
														'& .MuiCardHeader-content': {
															padding: '4px 0',
														},
														textAlign: 'left',
													}}
												/>
												<CardContent sx={{ py: 1, px: 2, flexGrow: 1 }}>
													<List dense sx={{ py: 0 }}>
														<ListItem sx={{ py: 0.5 }}>
															<ListItemIcon sx={{ minWidth: 25 }}>
																<InfoIcon color="success" fontSize="small" />
															</ListItemIcon>
															<ListItemText primary="6-month billing" />
														</ListItem>
														<ListItem sx={{ py: 0.5 }}>
															<ListItemIcon sx={{ minWidth: 25 }}>
																<InfoIcon color="success" fontSize="small" />
															</ListItemIcon>
															<ListItemText primary="Standard support" />
														</ListItem>
														<ListItem sx={{ py: 0.5 }}>
															<ListItemIcon sx={{ minWidth: 25 }}>
																<InfoIcon color="success" fontSize="small" />
															</ListItemIcon>
															<ListItemText primary="Save up to 10%" />
														</ListItem>
													</List>
												</CardContent>
												<CardActions
													sx={{
														p: 1.5,
														display: 'flex',
														justifyContent: 'center',
													}}
												>
													<Button
														color="success"
														fullWidth
														size="medium"
														variant="contained"
														onClick={() => this.openPurchaseModal(`${PHONE_PLAN_ID_SIXMONTH}`, 159)}
													>
														Purchase $159 / 6 months
													</Button>
												</CardActions>
											</Card>

											<Card
												sx={{
													display: 'flex',
													flexDirection: 'column',
													boxShadow: '2px 2px 10px rgba(0, 0, 0, 0.2)',
												}}
											>
												<CardHeader
													title="Annual Plan"
													titleTypography={{ variant: 'h6' }}
													avatar={<TimelineIcon sx={{ color: 'white' }} />}
													sx={{
														bgcolor: '#14B8A6',
														color: 'white',
														py: 1,
														'& .MuiCardHeader-content': {
															padding: '4px 0',
														},
														textAlign: 'left',
													}}
												/>
												<CardContent sx={{ py: 1, px: 2, flexGrow: 1 }}>
													<List dense sx={{ py: 0 }}>
														<ListItem sx={{ py: 0.5 }}>
															<ListItemIcon sx={{ minWidth: 25 }}>
																<InfoIcon color="success" fontSize="small" />
															</ListItemIcon>
															<ListItemText primary="Annual billing" />
														</ListItem>
														<ListItem sx={{ py: 0.5 }}>
															<ListItemIcon sx={{ minWidth: 25 }}>
																<InfoIcon color="success" fontSize="small" />
															</ListItemIcon>
															<ListItemText primary="Priority support" />
														</ListItem>
														<ListItem sx={{ py: 0.5 }}>
															<ListItemIcon sx={{ minWidth: 25 }}>
																<InfoIcon color="success" fontSize="small" />
															</ListItemIcon>
															<ListItemText primary="Free 2 months" />
														</ListItem>
														<ListItem sx={{ py: 0.5 }}>
															<ListItemIcon sx={{ minWidth: 25 }}>
																<InfoIcon color="success" fontSize="small" />
															</ListItemIcon>
															<ListItemText primary="No price fluctuation" />
														</ListItem>
													</List>
												</CardContent>
												<CardActions
													sx={{
														p: 1.5,
														display: 'flex',
														justifyContent: 'center',
													}}
												>
													<Button
														color="success"
														fullWidth
														size="medium"
														variant="contained"
														onClick={() => this.openPurchaseModal(`${PHONE_PLAN_ID_ANNUALLY}`, 299)}
													>
														Purchase Annually $299 / year
													</Button>
												</CardActions>
											</Card>
										</Box>
									</div>
								</div>
								<Divider></Divider>
								<div style={{ display: 'flex', padding: '10px' }}>
									<h3 style={{ margin: 'auto' }}>Phone Limit: {settings.phone_limit}</h3>
									{this.state.plans === 'maytapi-trial-live' ? <h3 style={{ margin: 'auto' }}>Agent Limit: {settings.agent_limit}</h3> : ''}
								</div>
								<TableContainer sx={{ maxHeight: 440 }}>
									<Table>
										<TableHead>
											<TableRow>
												<TableCell>Subscription</TableCell>
												<TableCell>Limit</TableCell>
												{/* 	<TableCell>Next Bill Date</TableCell> */}
												<TableCell width="4" style={{ textAlign: 'center' }}>
													{/**, paddingRight: 130 */}
													Status
												</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											{!products.activeSubs
												? {}
												: _.map(orderList, (data, i) => (
														<TableRow key={i}>
															<TableCell>{this.PLANS[data.data.subscription_plan_id]}</TableCell>
															<TableCell>
																{data.data.subscription_plan_id === 'maytapi-trial-live'
																	? settings.phone_limit +
																	  ' Phone - ' +
																	  settings.instagram_limit +
																	  ' Instagram - ' +
																	  settings.agent_limit +
																	  ' Agent'
																	: settings.phone_limit + ' Phone '}
																{settings.instagram_limit > 0 ? '-  Instagram' : ''}
															</TableCell>
															<TableCell style={{ textAlign: 'right' }}>
																<Stack direction="row" spacing={1}>
																	<Button
																		color="success"
																		variant="contained"
																		onClick={() => this.openPurchaseModal(`${PHONE_PLAN_ID}`, 29.9)}
																		size="small"
																		style={{ minWidth: 100 }}
																	>
																		Purchase <br />
																		$29.9 / month
																	</Button>
																	<Button
																		color="success"
																		variant="contained"
																		onClick={() => this.openPurchaseModal(`${PHONE_PLAN_ID_ANNUALLY}`, 299)}
																		size="small"
																		style={{ minWidth: 140 }}
																	>
																		Purchase Annually $299 / year
																	</Button>
																	<Button
																		color="error"
																		variant="contained"
																		onClick={() => {
																			this.setState({
																				helpModal: true,
																				packageName: 'trial',
																				subscriptionType: 'Trial Subscription',
																			});
																		}}
																		size="small"
																		style={{ minWidth: 60 }}
																	>
																		Cancel
																	</Button>
																</Stack>
															</TableCell>
														</TableRow>
												  ))}
										</TableBody>
									</Table>
								</TableContainer>
							</div>
						) : f_trial ? (
							<div>
								<Segment style={{ textAlign: 'center', color: 'red' }}>
									<p>{expiredTrialType ? 'Your ' + expiredTrialType + ' trial is over.' : 'Your trial is over.'}</p>
								</Segment>
							</div>
						) : (
							<Item className="userLimits" style={{ display: 'block', background: 'none', border: 'none', boxShadow: 'none', padding: '0' }}>
								{this.state.plans === 'live' ? (
									<div style={{ marginTop: '20px' }}>
										<div style={{ textAlign: 'center' }}>
											<h3>LiveChat Subscription</h3>
											<p>You can increase phones or agents limit in LiveChat Subscripton.</p>
										</div>
										{products && products.settings && products.settings.subscription_package === null ? (
											<div style={{ display: 'flex', marginTop: '20px', marginBottom: '20px' }}>
												<div style={{ margin: 'auto', textAlign: 'center' }}>
													<Button color="success" onClick={() => this.openPurchaseModal(`${LIVE_PLAN_ID}`, 29.9)}>
														Purchase LiveChat
													</Button>
													<p style={{ marginTop: '10px', color: 'red' }}>
														You don't subscribe to LiveChat package. You must purchase this package to use chat.
													</p>
												</div>
											</div>
										) : (
											''
										)}
										<div style={{ display: 'flex', marginTop: '20px', marginBottom: '20px' }}>
											<div style={{ margin: 'auto', display: 'flex' }}>
												<Stack spacing={2} direction="row">
													<Button
														color="success"
														fullWidth
														onClick={
															_.find(this.props.product.activeSubs, { data: { subscription_plan_id: `${account_phone}` } })
																? this.openNewModal({
																		selectedSubs: phoneSubs.data.subscription_id,
																		currentQuantity: phoneSubs.data.quantity || phoneSubs.data.new_quantity,
																		old_quantity: phoneSubs.data.quantity || phoneSubs.data.new_quantity,
																		user_id: phoneSubs.data.user_id,
																		plan_id: phoneSubs.data.subscription_plan_id,
																		price: account_phone_price,
																  })
																: () => this.openPurchaseModal(`${account_phone}`, account_phone_price)
														}
														variant="contained"
														sx={{ marginTop: '15px' }}
													>
														Add New Phone Number
													</Button>
													<Button
														color="success"
														fullWidth
														onClick={
															_.find(this.props.product.activeSubs, { data: { subscription_plan_id: `${AGENT_PLAN_ID}` } })
																? this.openNewModal({
																		selectedSubs: agentSubs.data.subscription_id,
																		user_id: agentSubs.data.user_id,
																		currentQuantity: agentSubs.data.quantity || agentSubs.data.new_quantity,
																		old_quantity: agentSubs.data.quantity || agentSubs.data.new_quantity,
																		plan_id: agentSubs.data.subscription_plan_id,
																		price: 20,
																  })
																: () => this.openPurchaseModal(`${AGENT_PLAN_ID}`, 20)
														}
														variant="contained"
														style={{ marginTop: '15px' }}
													>
														Add New Agent
													</Button>
												</Stack>
											</div>

											{/* <div style={{ margin: 'auto' }}>
										<a
											color="instagram"
											onClick={
												_.find(this.props.product.activeSubs, { data: { subscription_plan_id: `${INSTAGRAM_PLAN_ID}` } })
													? this.openNewModal({
															selectedSubs: instagramSubs.data.subscription_id,
															currentQuantity: instagramSubs.data.quantity || instagramSubs.data.new_quantity,
															user_id: instagramSubs.data.user_id,
															plan_id: instagramSubs.data.subscription_plan_id,
															price: 30,
													  })
													: () => this.openPurchaseModal(`${INSTAGRAM_PLAN_ID}`, 30)
											}
										>
											Add New Instagram Account
										</a>
									</div> */}
											{/* <div style={{ margin: 'auto' }}>
										<a primary onClick={() => this.openPurchaseModal(`${HISTORY_DATA_ID}`, 99, true)}>
											Take Phone History Data Package
										</a>
									</div> */}
										</div>
										<Divider></Divider>
										<div style={{ display: 'flex', padding: '10px' }}>
											<h3 style={{ margin: 'auto' }}>Phone Limit: {settings.phone_limit}</h3>
											<h3 style={{ margin: 'auto' }}>Agent Limit: {settings.agent_limit}</h3>
										</div>
									</div>
								) : this.state.plans === 'api' || this.state.plans === 'maytapi-api' ? (
									<div style={{ marginTop: '20px' }}>
										<div style={{ textAlign: 'center' }}>
											<h3>Base Subscription</h3>
											<p>You can increase phones limit in API Subscripton.</p>
										</div>

										<div style={{ display: 'flex', marginTop: '10px', marginBottom: '20px' }}>
											<div style={{ margin: 'auto', width: '100%', padding: '0 16px' }}>
												<Box
													sx={{
														display: 'flex',
														flexDirection: { xs: 'column', md: 'row' },
														gap: 2,
														justifyContent: 'center',
														marginY: 2,
														'& > .MuiCard-root': {
															width: { xs: '100%', md: '300px' },
															maxWidth: { xs: '100%', md: '350px' },
														},
													}}
												>
													<Card
														sx={{
															display: 'flex',
															flexDirection: 'column',
															boxShadow: '2px 2px 10px rgba(0, 0, 0, 0.2)',
															mb: { xs: 2, md: 0 },
														}}
													>
														<CardHeader
															title="Monthly Plan"
															titleTypography={{ variant: 'h6' }}
															avatar={<CalendarMonthIcon sx={{ color: 'white' }} />}
															sx={{
																bgcolor: '#14B8A6',
																color: 'white',
																py: 1,
																'& .MuiCardHeader-content': {
																	padding: '4px 0',
																},
																textAlign: 'left',
															}}
														/>
														<CardContent sx={{ py: 1, px: 2, flexGrow: 1 }}>
															<List dense sx={{ py: 0 }}>
																<ListItem sx={{ py: 0.5 }}>
																	<ListItemIcon sx={{ minWidth: 25 }}>
																		<InfoIcon color="success" fontSize="small" />
																	</ListItemIcon>
																	<ListItemText primary="Monthly billing" />
																</ListItem>
																<ListItem sx={{ py: 0.5 }}>
																	<ListItemIcon sx={{ minWidth: 25 }}>
																		<InfoIcon color="success" fontSize="small" />
																	</ListItemIcon>
																	<ListItemText primary="Basic support" />
																</ListItem>
															</List>
														</CardContent>
														<CardActions
															sx={{
																marginTop: 'auto',
																p: 1.5,
																display: 'flex',
																justifyContent: 'center',
															}}
														>
															<Button
																color="success"
																fullWidth
																size="medium"
																variant="contained"
																onClick={
																	_.find(this.props.product.activeSubs, {
																		data: { subscription_plan_id: `${account_phone}` },
																	})
																		? this.openNewModal({
																				selectedSubs: phoneSubs.data.subscription_id,
																				currentQuantity: phoneSubs.data.quantity || phoneSubs.data.new_quantity,
																				old_quantity: phoneSubs.data.quantity || phoneSubs.data.new_quantity,
																				user_id: phoneSubs.data.user_id,
																				plan_id: phoneSubs.data.subscription_plan_id,
																				price: account_phone_price,
																		  })
																		: () => this.openPurchaseModal(`${account_phone}`, account_phone_price)
																}
															>
																Add New Phone Number {account_phone_price}$ / month
															</Button>
														</CardActions>
													</Card>

													<Card
														sx={{
															display: 'flex',
															flexDirection: 'column',
															boxShadow: '2px 2px 10px rgba(0, 0, 0, 0.2)',
															mb: { xs: 2, md: 0 },
														}}
													>
														<CardHeader
															title="6 Month Plan"
															titleTypography={{ variant: 'h6' }}
															avatar={<CalendarMonthIcon sx={{ color: 'white' }} />}
															sx={{
																bgcolor: '#14B8A6',
																color: 'white',
																py: 1,
																'& .MuiCardHeader-content': {
																	padding: '4px 0',
																},
																textAlign: 'left',
															}}
														/>
														<CardContent sx={{ py: 1, px: 2, flexGrow: 1 }}>
															<List dense sx={{ py: 0 }}>
																<ListItem sx={{ py: 0.5 }}>
																	<ListItemIcon sx={{ minWidth: 25 }}>
																		<InfoIcon color="success" fontSize="small" />
																	</ListItemIcon>
																	<ListItemText primary="6-month billing" />
																</ListItem>
																<ListItem sx={{ py: 0.5 }}>
																	<ListItemIcon sx={{ minWidth: 25 }}>
																		<InfoIcon color="success" fontSize="small" />
																	</ListItemIcon>
																	<ListItemText primary="Standard support" />
																</ListItem>
																<ListItem sx={{ py: 0.5 }}>
																	<ListItemIcon sx={{ minWidth: 25 }}>
																		<InfoIcon color="success" fontSize="small" />
																	</ListItemIcon>
																	<ListItemText primary="Save up to 10%" />
																</ListItem>
															</List>
														</CardContent>
														<CardActions
															sx={{
																p: 1.5,
																display: 'flex',
																justifyContent: 'center',
															}}
														>
															<Button
																color="success"
																fullWidth
																size="medium"
																variant="contained"
																onClick={() => this.openPurchaseModal(`${PHONE_PLAN_ID_SIXMONTH}`, 159)}
															>
																Add New Phone Number {account_phone_6monthly_price}$ / 6 months
															</Button>
														</CardActions>
													</Card>

													<Card
														sx={{
															display: 'flex',
															flexDirection: 'column',
															boxShadow: '2px 2px 10px rgba(0, 0, 0, 0.2)',
														}}
													>
														<CardHeader
															title="Annual Plan"
															titleTypography={{ variant: 'h6' }}
															avatar={<TimelineIcon sx={{ color: 'white' }} />}
															sx={{
																bgcolor: '#14B8A6',
																color: 'white',
																py: 1,
																'& .MuiCardHeader-content': {
																	padding: '4px 0',
																},
																textAlign: 'left',
															}}
														/>
														<CardContent sx={{ py: 1, px: 2, flexGrow: 1 }}>
															<List dense sx={{ py: 0 }}>
																<ListItem sx={{ py: 0.5 }}>
																	<ListItemIcon sx={{ minWidth: 25 }}>
																		<InfoIcon color="success" fontSize="small" />
																	</ListItemIcon>
																	<ListItemText primary="Annual billing" />
																</ListItem>
																<ListItem sx={{ py: 0.5 }}>
																	<ListItemIcon sx={{ minWidth: 25 }}>
																		<InfoIcon color="success" fontSize="small" />
																	</ListItemIcon>
																	<ListItemText primary="Priority support" />
																</ListItem>
																<ListItem sx={{ py: 0.5 }}>
																	<ListItemIcon sx={{ minWidth: 25 }}>
																		<InfoIcon color="success" fontSize="small" />
																	</ListItemIcon>
																	<ListItemText primary="Free 2 months" />
																</ListItem>
																<ListItem sx={{ py: 0.5 }}>
																	<ListItemIcon sx={{ minWidth: 25 }}>
																		<InfoIcon color="success" fontSize="small" />
																	</ListItemIcon>
																	<ListItemText primary="No price fluctuation" />
																</ListItem>
															</List>
														</CardContent>
														<CardActions
															sx={{
																marginTop: 'auto',
																p: 1.5,
																display: 'flex',
																justifyContent: 'center',
															}}
														>
															<Button
																color="success"
																fullWidth
																size="medium"
																variant="contained"
																onClick={
																	_.find(this.props.product.activeSubs, {
																		data: { subscription_plan_id: `${account_phone_annually}` },
																	})
																		? this.openNewModal({
																				selectedSubs: phoneSubs.data && phoneSubs.data.subscription_id,
																				currentQuantity:
																					(phoneSubs.data && phoneSubs.data.quantity) ||
																					(phoneSubs.data && phoneSubs.data.new_quantity),
																				old_quantity:
																					(phoneSubs.data && phoneSubs.data.quantity) ||
																					(phoneSubs.data && phoneSubs.data.new_quantity),
																				user_id: phoneSubs.data && phoneSubs.data.user_id,
																				plan_id: phoneSubs.data && phoneSubs.data.subscription_plan_id,
																				price: account_phone_annually_price,
																		  })
																		: () =>
																				this.openPurchaseModal(
																					`${account_phone_annually}`,
																					account_phone_annually_price
																				)
																}
															>
																Add New Phone Number {account_phone_annually_price}$ / year
															</Button>
														</CardActions>
													</Card>
												</Box>
											</div>
										</div>
										{settings.phone_limit >= 45 && products && products.settings && products.settings.phone19 ? (
											<div style={{ display: 'flex', marginTop: '20px', marginBottom: '20px' }}>
												<div style={{ margin: 'auto' }}>
													<Button
														color="success"
														/* disabled={products && products.settings && products.settings.subscription_package === null} */
														fullWidth
														size="medium"
														variant="contained"
														sx={{ marginTop: '15px' }}
														onClick={
															_.find(this.props.product.activeSubs, { data: { subscription_plan_id: `${PHONE_19_PLAN_ID}` } })
																? this.openNewModal({
																		selectedSubs: phoneSubs19.data.subscription_id,
																		currentQuantity: phoneSubs19.data.quantity || phoneSubs19.data.new_quantity,
																		old_quantity: phoneSubs19.data.quantity || phoneSubs19.data.new_quantity,
																		user_id: phoneSubs19.data.user_id,
																		plan_id: phoneSubs19.data.subscription_plan_id,
																		price: 19,
																  })
																: () => this.openPurchaseModal(`${PHONE_19_PLAN_ID}`, 19)
														}
													>
														Add New Phone Number 19$
													</Button>
												</div>
											</div>
										) : null}
										{settings.phone_limit >= 90 && products && products.settings && products.settings.phone15 ? (
											<div style={{ display: 'flex', marginTop: '20px', marginBottom: '20px' }}>
												<div style={{ margin: 'auto' }}>
													<Button
														color="success"
														disabled={products && products.settings && products.settings.subscription_package === null}
														fullWidth
														size="medium"
														variant="contained"
														sx={{ marginTop: '15px' }}
														onClick={
															_.find(this.props.product.activeSubs, { data: { subscription_plan_id: `${PHONE_15_PLAN_ID}` } })
																? this.openNewModal({
																		selectedSubs: phoneSubs15.data.subscription_id,
																		currentQuantity: phoneSubs15.data.quantity || phoneSubs15.data.new_quantity,
																		old_quantity: phoneSubs15.data.quantity || phoneSubs15.data.new_quantity,
																		user_id: phoneSubs15.data.user_id,
																		plan_id: phoneSubs15.data.subscription_plan_id,
																		price: 15,
																  })
																: () => this.openPurchaseModal(`${PHONE_15_PLAN_ID}`, 15)
														}
													>
														Add New Phone Number 15$
													</Button>
												</div>
											</div>
										) : null}

										<Divider></Divider>
										<div style={{ display: 'flex', padding: '10px' }}>
											<h3 style={{ margin: 'auto' }}>Phone Limit: {settings.phone_limit}</h3>
										</div>
									</div>
								) : this.state.plans === 'liveapi' ? (
									<div>
										<div style={{ textAlign: 'center' }}>
											<h3>Live+API Subscription</h3>
											<p>You can increase phones or agents limit in LiveChat Subscripton.</p>
										</div>
										{products && products.settings && products.settings.subscription_package === null ? (
											<div style={{ display: 'flex', marginTop: '20px', marginBottom: '20px' }}>
												<div style={{ margin: 'auto', textAlign: 'center' }}>
													<Button color="success" onClick={() => this.openPurchaseModal(`${LIVE_PLAN_ID}`, 29.9)}>
														Purchase LiveChat
													</Button>
													<p style={{ marginTop: '10px', color: 'red' }}>
														You don't subscribe to LiveChat package. You must purchase this package to use chat.
													</p>
												</div>
											</div>
										) : (
											''
										)}
										<div style={{ display: 'flex', marginTop: '20px', marginBottom: '20px' }}>
											<div style={{ margin: 'auto' }}>
												<Button
													color="success"
													fullWidth
													size="medium"
													variant="contained"
													sx={{ marginTop: '15px' }}
													onClick={
														_.find(this.props.product.activeSubs, { data: { subscription_plan_id: `${account_phone}` } })
															? this.openNewModal({
																	selectedSubs: phoneSubs.data.subscription_id,
																	currentQuantity: phoneSubs.data.quantity || phoneSubs.data.new_quantity,
																	old_quantity: phoneSubs.data.quantity || phoneSubs.data.new_quantity,
																	user_id: phoneSubs.data.user_id,
																	plan_id: phoneSubs.data.subscription_plan_id,
																	price: account_phone_price,
															  })
															: () => this.openPurchaseModal(`${account_phone}`, account_phone_price)
													}
												>
													Add New Phone Number
												</Button>
											</div>
											{/* <div style={{ margin: 'auto' }}>
										<a
											color="instagram"
											onClick={
												_.find(this.props.product.activeSubs, { data: { subscription_plan_id: `${INSTAGRAM_PLAN_ID}` } })
													? this.openNewModal({
															selectedSubs: instagramSubs.data.subscription_id,
															currentQuantity: instagramSubs.data.quantity || instagramSubs.data.new_quantity,
															user_id: instagramSubs.data.user_id,
															plan_id: instagramSubs.data.subscription_plan_id,
															price: 30,
													  })
													: () => this.openPurchaseModal(`${INSTAGRAM_PLAN_ID}`, 30)
											}
										>
											Add New Instagram Account
										</a>
									</div> */}
											{/* <div style={{ margin: 'auto' }}>
										<a primary onClick={() => this.openPurchaseModal(`${HISTORY_DATA_ID}`, 99, true)}>
											Take Phone History Data Package
										</a>
									</div> */}
										</div>
										<Divider></Divider>
										<div style={{ display: 'flex', padding: '10px' }}>
											<h3 style={{ margin: 'auto' }}>Phone Limit: {settings.phone_limit}</h3>
											<h3 style={{ margin: 'auto' }}>Agent Limit: {settings.agent_limit}</h3>
										</div>
									</div>
								) : (
									<div style={{ marginTop: '20px' }}>
										<div style={{ textAlign: 'center' }}>
											<h3>Enterprise Subscription</h3>
											<p>You can't increase phones or agents limit in Enterprise Subscripton.</p>
											<p>If you want more phones or agents, you have to contact us.</p>
										</div>
										<div style={{ marginTop: '20px', marginBottom: '20px' }}>
											<div>
												<a href="/contact">
													<Button variant="contained" color="primary">
														Contact Us
													</Button>
												</a>
											</div>
										</div>
										<Divider></Divider>
										<div style={{ display: 'flex', padding: '10px' }}>
											<h3 style={{ margin: 'auto' }}>Phone Limit: {settings.phone_limit}</h3>
											<h3 style={{ margin: 'auto' }}>Agent Limit: {settings.agent_limit}</h3>
										</div>
									</div>
								)}

								<Divider></Divider>
								{!this.state.messageOnScreen ? (
									''
								) : (
									<Segment style={{ textAlign: 'center', color: this.state.messageColor }}>
										<p>{this.state.messageOnScreen}</p>
									</Segment>
								)}
								<div style={{ display: 'flex' }}></div>
								{products.activeSubs && products.activeSubs.length ? (
									<TableContainer sx={{ maxHeight: 440 }}>
										<Table>
											<TableHead>
												<TableRow>
													<TableCell width="1">Subscription</TableCell>
													<TableCell width="2">Limit</TableCell>
													<TableCell width="2">Status</TableCell>
													<TableCell width="1">Next Bill Date</TableCell>
													<TableCell width="2">Next Payment Amount</TableCell>
													<TableCell width="2">Will Be Disable</TableCell>
													<TableCell width="6" style={{ textAlign: 'right' }}>
														Actions
													</TableCell>
												</TableRow>
											</TableHead>
											<TableBody>
												{!products.activeSubs
													? {}
													: _.map(orderList, (data, i) => (
															<TableRow key={i}>
																<TableCell>
																	<strong>
																		{data.custom_data || data.data.subscription_plan_id === 'maytapi-custom-api'
																			? 'Custom'
																			: this.PLANS[data.data.subscription_plan_id]}
																		{data.data.status === 'temporary' ? ' (pending payment)' : ''}
																	</strong>
																</TableCell>
																<TableCell>
																	{data.data.subscription_plan_id === 'maytapi-custom-api'
																		? data.data.quantity + ' Phone - ' + products.settings.agent_limit + ' Agent'
																		: this.PLANS[data.data.subscription_plan_id] === 'LIVE'
																		? '1 Phone - 1 Agent'
																		: (data.data.new_quantity ||
																				data.data.quantity ||
																				'' + this.PLANS[data.data.subscription_plan_id]) +
																		  (data.data.pending_update ? ` will be ${data.data.scheduled_quantity}` : '')}
																</TableCell>
																<TableCell>
																	<Stack spacing={2} direction="row">
																		<CircleIcon
																			color={
																				(data.data.subscription_plan_id === 'maytapi-custom-api'
																					? 'success'
																					: data.data.status &&
																					  sub_status[data.data.status] &&
																					  sub_status[data.data.status].color) || 'disabled'
																			}
																			fontSize="small"
																		/>
																		<strong>
																			{(data.data.status &&
																				sub_status[data.data.status] &&
																				sub_status[data.data.status].text) ||
																				''}
																		</strong>
																		{data.data.pending_update ? ' - Pending Reduce' : ''}
																	</Stack>
																</TableCell>
																{data.data.status === 'past_due' ? (
																	<TableCell>
																		<Stack spacing={4}>
																			<p style={{ marginBottom: 0 }}>
																				Last Try Date:{' '}
																				<strong>{moment(data.data.event_time).format('DD-MM-YYYY')}</strong>
																			</p>
																			<p style={{ marginTop: 0 }}>
																				Next Try Date:{' '}
																				<strong>{moment(data.data.next_retry_date).format('DD-MM-YYYY')}</strong>
																			</p>
																			<p style={{ marginTop: 0 }}>
																				Payment Attempts: <strong>{data.data.attempt_number || 1}</strong>
																			</p>
																			<p style={{ marginTop: 0 }}>
																				Attempts Remaining:{' '}
																				<strong>{4 - parseInt(data.data.attempt_number || 1)}</strong>
																			</p>
																		</Stack>
																	</TableCell>
																) : (
																	<TableCell>
																		{this.PLANS[data.data.subscription_plan_id || data.data.product_id] !== 'HISTORY'
																			? data.data.next_bill_date
																			: 'One-off Purchase'}
																	</TableCell>
																)}

																<TableCell>
																	{/* <strong>
																		{data.data.next_payment_amount ||
																			data.data.new_price ||
																			data.data.amount ||
																			parseInt(data.data.unit_price) * parseInt(data.data.quantity)}
																	</strong> */}
																	<Button
																		color="success"
																		size="small"
																		variant="contained"
																		onClick={this.getPaymentHistory({ subscription_id: data.data.subscription_id })}
																	>
																		Check Payment
																	</Button>
																	{data.data.pending_update ? ` will be ${data.data.new_payment_amount}` : ''}
																</TableCell>
																<TableCell>
																	{data && data.data && data.data.pending_update
																		? (data && data.data && data.data.phone_ids ? data.data.phone_ids.join(', ') : '') || ''
																		: null}
																</TableCell>

																<TableCell style={{ textAlign: 'right', display: 'flex' }}>
																	{(data.custom_data && data.custom_data.subscription_plan_id === 'maytapi-custom-api') ||
																	data.data.subscription_plan_id === 'maytapi-custom-api' ? (
																		<div style={{ marginLeft: 'auto', display: 'flex' }}>
																			{data.data.subscription_id ? (
																				<div
																					className="payment-buttons"
																					size="mini"
																					style={{ display: 'flex', marginLeft: 'auto' }}
																				>
																					<Button
																						color="success"
																						size="small"
																						variant="contained"
																						onClick={this.getPaymentHistory({
																							subscription_id: data.data.subscription_id,
																						})}
																					>
																						Invoice
																					</Button>

																					<Button
																						color="secondary"
																						size="small"
																						variant="outlined"
																						sx={{ marginLeft: '8px' }}
																						onClick={this.getPaymentHistory({
																							subscription_id: data.data.subscription_id,
																						})}
																					>
																						Saved Payment Method
																					</Button>
																					<Button
																						disabled={data.data.status === 'temporary'}
																						size="small"
																						color="info"
																						variant="contained"
																						sx={{ marginLeft: '10px' }}
																						onClick={this.updatePayment({
																							subscription_id: data.data.subscription_id,
																						})}
																					>
																						Update Payment Method
																					</Button>
																					<a href="/contact">
																						<Button size="small" variant="contained" color="primary">
																							Contact Us
																						</Button>
																					</a>
																				</div>
																			) : (
																				<a href="/contact">
																					<Button size="small" variant="contained" color="primary">
																						Contact Us
																					</Button>
																				</a>
																			)}
																		</div>
																	) : this.PLANS[data.data.subscription_plan_id] === 'LIVE' ||
																	  this.PLANS[data.data.subscription_plan_id] === 'API' ||
																	  this.PLANS[data.data.subscription_plan_id] === 'LIVEAPI' ? (
																		<div
																			className="payment-buttons"
																			size="mini"
																			style={{ display: 'flex', marginLeft: 'auto' }}
																		>
																			{console.log('data.data.status', data.data.status)}
																			{data.data.status === 'paused' ? (
																				<Button
																					color="warning"
																					size="small"
																					variant="contained"
																					onClick={() =>
																						this.openRestartModal({
																							subscription_id: data.data.subscription_id,
																							next_payment_amount:
																								data.data.next_payment_amount ||
																								data.data.new_price ||
																								data.data.amount ||
																								parseInt(data.data.unit_price || 0) *
																									parseInt(data.data.quantity || 1),
																							subscription_name:
																								this.PLANS[data.data.subscription_plan_id] || 'Subscription',
																						})
																					}
																				>
																					Restart
																				</Button>
																			) : (
																				''
																			)}
																			<Button
																				color="success"
																				size="small"
																				variant="contained"
																				sx={{ marginLeft: '10px' }}
																				onClick={this.getPaymentHistory({ subscription_id: data.data.subscription_id })}
																			>
																				Invoice
																			</Button>

																			<Button
																				color="secondary"
																				size="small"
																				variant="outlined"
																				sx={{ marginLeft: '8px' }}
																				onClick={this.getPaymentHistory({ subscription_id: data.data.subscription_id })}
																			>
																				Saved Payment Method
																			</Button>
																			<Button
																				disabled={data.data.status === 'temporary'}
																				size="small"
																				color="info"
																				variant="contained"
																				sx={{ marginLeft: '10px' }}
																				onClick={this.updatePayment({ subscription_id: data.data.subscription_id })}
																			>
																				Update Payment Method
																			</Button>
																			{/* {this.PLANS[data.data.subscription_plan_id] !== 'LIVEAPI' ? (
																	<a
																		disabled={data.data.status === 'temporary'}
																		color="green"
																		size="mini"
																		style={{ marginLeft: '10px' }}
																		onClick={this.openChangePlanModalDouble(
																			data.data.subscription_plan_id,
																			data.data.subscription_id
																		)}
																	>
																		Change to Live + API
																	</a>
																) : null}
																{this.PLANS[data.data.subscription_plan_id] !== 'LIVEAPI' ? (
																	<a
																		disabled={data.data.status === 'temporary'}
																		primary
																		size="mini"
																		style={{ marginLeft: '10px' }}
																		onClick={this.openChangePlanModal(
																			data.data.subscription_plan_id,
																			data.data.subscription_id
																		)}
																	>
																		{this.PLANS[data.data.subscription_plan_id] === 'LIVE'
																			? 'Change to API'
																			: 'Change to LIVE'}
																	</a>
																) : null} */}
																			<Popup
																				header="You can't unsubscribe before cancelling other subscriptions."
																				content="Please unsubscribe from other plans."
																				open={this.state.openPopup}
																				position="top center"
																				style={{ zIndex: 1 }}
																				trigger={
																					<Button
																						disabled={data.data.status === 'temporary'}
																						color="error"
																						variant="contained"
																						onClick={() => {
																							products.activeSubs.length > 1
																								? this.openPop('openPopup')
																								: this.setState({
																										helpModal: true,
																										subscription_id:
																											(data && data.data && data.data.subscription_id) ||
																											'',
																										plan_id:
																											(data &&
																												data.data &&
																												data.data.subscription_plan_id) ||
																											'',
																										user_id: (data && data.data && data.data.user_id) || '',
																										quantity_id:
																											(data && data.data && data.data.quantity) ||
																											data.data.new_quantity ||
																											'',
																										subscriptionType: 'API Subscription',
																								  });
																						}}
																						size="small"
																						sx={{ marginLeft: '10px' }}
																					>
																						Unsubscribe
																					</Button>
																				}
																			/>
																		</div>
																	) : data.data.nobuttons ? null : (
																		<div
																			className="payment-buttons"
																			size="mini"
																			style={{ display: 'flex', marginLeft: 'auto' }}
																		>
																			{data.data.status === 'paused' ? (
																				<Button
																					color="warning"
																					size="small"
																					variant="contained"
																					onClick={() =>
																						this.openRestartModal({
																							subscription_id: data.data.subscription_id,
																							next_payment_amount:
																								data.data.next_payment_amount ||
																								data.data.new_price ||
																								data.data.amount ||
																								parseInt(data.data.unit_price || 0) *
																									parseInt(data.data.quantity || 1),
																							subscription_name:
																								this.PLANS[data.data.subscription_plan_id] || 'Subscription',
																						})
																					}
																				>
																					Restart
																				</Button>
																			) : (
																				''
																			)}
																			<Button
																				color="success"
																				size="small"
																				variant="contained"
																				sx={{ marginLeft: '10px' }}
																				onClick={this.getPaymentHistory({ subscription_id: data.data.subscription_id })}
																			>
																				Invoice
																			</Button>

																			<Button
																				color="secondary"
																				size="small"
																				variant="outlined"
																				sx={{ marginLeft: '8px' }}
																				onClick={this.getPaymentHistory({ subscription_id: data.data.subscription_id })}
																			>
																				Saved Payment Method
																			</Button>
																			<Button
																				disabled={data.data.status === 'temporary'}
																				size="small"
																				color="info"
																				variant="contained"
																				sx={{ marginLeft: '10px' }}
																				onClick={this.updatePayment({ subscription_id: data.data.subscription_id })}
																			>
																				Update Payment Method
																			</Button>
																			<Popup
																				header="You can't edit PHONE subscription before cancelling PHONE19."
																				content="Please unsubscribe from PHONE19 plan."
																				open={
																					this.PLANS[data.data.subscription_plan_id] === 'PHONE' &&
																					this.state.openPopup19Update
																				}
																				position="top center"
																				style={{ zIndex: 1 }}
																				trigger={
																					<Button
																						disabled={data.data.status === 'temporary'}
																						color="success"
																						variant="contained"
																						onClick={() => {
																							this.PLANS[data.data.subscription_plan_id] === 'PHONE' &&
																							phoneSubs19
																								? this.openPop('openPopup19Update')
																								: this.openModal({
																										selectedSubs: data.data.subscription_id,
																										user_id: data.data.user_id,
																										plan_id: data.data.subscription_plan_id,
																										price:
																											this.PLANS[data.data.subscription_plan_id] ===
																											'AGENT'
																												? 20
																												: this.PLANS[data.data.subscription_plan_id] ===
																												  'PHONE19'
																												? 19
																												: this.PLANS[data.data.subscription_plan_id] ===
																												  'PHONE15'
																												? 15
																												: account_phone_price,
																										old_quantity:
																											data.data.quantity || data.data.new_quantity,
																								  });
																						}}
																						size="small"
																						sx={{ marginLeft: '10px' }}
																					>
																						Update
																					</Button>
																				}
																			/>
																			<Popup
																				header="You can't edit PHONE subscription before cancelling PHONE19."
																				content="Please unsubscribe from PHONE19 plan."
																				open={
																					this.PLANS[data.data.subscription_plan_id] === 'PHONE' &&
																					this.state.openPopup19
																				}
																				position="top center"
																				style={{ zIndex: 1 }}
																				trigger={
																					<Button
																						disabled={data.data.status === 'temporary'}
																						color="error"
																						variant="contained"
																						onClick={() => {
																							this.PLANS[data.data.subscription_plan_id] === 'PHONE' &&
																							phoneSubs19
																								? this.openPop('openPopup19')
																								: this.setState({
																										helpModal: true,
																										packageName: 'subscription',
																										subscription_id:
																											(data && data.data && data.data.subscription_id) ||
																											'',
																										plan_id:
																											(data &&
																												data.data &&
																												data.data.subscription_plan_id) ||
																											'',
																										user_id: (data && data.data && data.data.user_id) || '',
																										quantity_id:
																											(data && data.data && data.data.quantity) ||
																											data.data.new_quantity ||
																											'',
																										subscriptionType: 'Phone Subscription',
																								  });
																						}}
																						size="small"
																						sx={{ marginLeft: '10px' }}
																					>
																						Unsubscribe
																					</Button>
																				}
																			/>
																		</div>
																	)}
																</TableCell>
															</TableRow>
													  ))}
											</TableBody>
										</Table>
									</TableContainer>
								) : (
									''
								)}
								{deletedList && deletedList.length > 0 ? (
									<>
										<Divider />
										<TableContainer sx={{ maxHeight: 440 }}>
											<Table>
												<TableHead>
													<TableRow>
														<TableCell width="1">Subscription</TableCell>
														<TableCell width="2">Limit</TableCell>
														<TableCell width="2">Status</TableCell>
														<TableCell width="1">Date</TableCell>
														<TableCell width="6" style={{ textAlign: 'right' }}>
															{/**, paddingRight: 130  */}
															Actions
														</TableCell>
													</TableRow>
												</TableHead>

												<TableBody>
													{_.map(deletedList, (data, i) => (
														<TableRow key={i}>
															<TableCell>
																<strong>{this.PLANS[data.data.subscription_plan_id]}</strong>
															</TableCell>
															<TableCell>
																{data.data.subscription_plan_id === 'maytapi-custom-api'
																	? data.data.quantity + ' Phone - ' + products.settings.agent_limit + ' Agent'
																	: this.PLANS[data.data.subscription_plan_id] === 'LIVE'
																	? '1 Phone - 1 Agent'
																	: data.data.new_quantity ||
																	  data.data.quantity ||
																	  ' ' + this.PLANS[data.data.subscription_plan_id]}
															</TableCell>
															<TableCell>
																<Stack spacing={2} direction="row">
																	<CircleIcon
																		color={
																			(data.data.status &&
																				sub_status[data.data.status] &&
																				sub_status[data.data.status].color) ||
																			'disabled'
																		}
																		fontSize="small"
																	/>
																	<strong>
																		{(data.data.status &&
																			sub_status[data.data.status] &&
																			sub_status[data.data.status].text) ||
																			''}
																	</strong>
																</Stack>
															</TableCell>
															<TableCell>{data.data.event_time}</TableCell>
															<TableCell style={{ textAlign: 'right' }}>
																<Button
																	color="success"
																	size="small"
																	variant="contained"
																	onClick={this.getPaymentHistory({ subscription_id: data.data.subscription_id })}
																>
																	Invoice
																</Button>

																<Button
																	color="secondary"
																	size="small"
																	variant="outlined"
																	sx={{ marginLeft: '8px' }}
																	onClick={this.getPaymentHistory({ subscription_id: data.data.subscription_id })}
																>
																	Saved Payment Method
																</Button>
															</TableCell>
														</TableRow>
													))}
												</TableBody>
											</Table>
										</TableContainer>
									</>
								) : null}
							</Item>
						)}
					</Stack>
					{/*create modal*/}
					<Modal open={this.state.openCreate} onClose={this.closeModal} style={{ width: 500 }}>
						<Header icon="trash" content="Subscribe Package" />
						<Modal.Content style={{ textAlign: 'center' }}>
							<p>Please enter the amount to update the package:</p>
						</Modal.Content>
						<Modal.Content style={{ display: 'flex' }}>
							<Modal.Content style={{ width: 250, textAlign: 'center' }}>
								<Dropdown
									options={this.state.options}
									placeholder="Choose Quantity"
									selection
									value={crPhoneQu}
									defaultValue={1}
									onAddItem={this.handleAddition}
									onChange={this.handleChangeCrPhoneQu}
								/>
							</Modal.Content>
							<Modal.Content style={{ width: 250, textAlign: 'center', margin: 'auto' }}>
								<p>The amount per product is: {this.state.crPhoneQu * this.state.amountPrice}$</p>
							</Modal.Content>
						</Modal.Content>
						<Modal.Actions style={{ textAlign: 'center' }}>
							<Stack spacing={2} direction="row">
								<Button color="error" variant="contained" startIcon={<CloseIcon />} onClick={this.closeModal}>
									Back
								</Button>
								<Button
									color="success"
									variant="contained"
									startIcon={<CheckIcon />}
									onClick={this.checkoutHandler(this.state.crPhoneQu, `${account_phone}`)}
								>
									Proceed
								</Button>
							</Stack>
						</Modal.Actions>
					</Modal>
					{/*update modal*/}
					<Modal open={this.state.open} onClose={this.closeModal} style={{ width: 500 }}>
						<Header icon="redo" content="Update Package" />
						<Modal.Content style={{ textAlign: 'center' }}>
							<p>Please enter the amount to update the package:</p>
						</Modal.Content>
						<Modal.Content style={{ display: 'flex' }}>
							<Modal.Content style={{ width: 250, textAlign: 'center' }}>
								<Dropdown
									options={
										this.props.product.settings.update_limited
											? _.filter(this.state.options, (it) => it.value >= this.state.selectedOldQuantity)
											: this.state.options
									}
									placeholder="Choose Quantity"
									selection
									value={quantityUpdate}
									defaultValue={this.state.selectedOldQuantity || 1}
									onAddItem={this.handleAddition}
									onChange={this.handleChangeUpdate}
								/>
							</Modal.Content>
							<Modal.Content style={{ width: 250, textAlign: 'center', margin: 'auto' }}>
								<p>Total amount is: {this.state.quantityUpdate * this.state.amountPrice}$</p>
							</Modal.Content>
						</Modal.Content>
						<Modal.Content style={{ textAlign: 'center' }}>
							<p>Reducing your phone quantity will take effect on your next billing date. Until then, all your phones will remain active.</p>
							<p>
								If you proceed, you'll need to select which phones to disable on the next screen. Selected phones will continue working until
								the next billing cycle.
							</p>
						</Modal.Content>

						<Modal.Actions style={{ textAlign: 'center' }}>
							<Stack spacing={2} direction="row">
								<Button color="error" variant="contained" startIcon={<CloseIcon />} onClick={this.closeModal}>
									Back
								</Button>
								<Button color="success" variant="contained" startIcon={<CheckIcon />} onClick={this.openPreviewModal({ add: false })}>
									Proceed
								</Button>
							</Stack>
						</Modal.Actions>
					</Modal>
					{/*add up model*/}
					<Modal open={this.state.openNew} onClose={this.closeModal} style={{ width: 500 }}>
						<Header icon="dollar" content={'Add new ' + this.PLANS[this.state.selectedPlanid]} />
						<Modal.Content style={{ textAlign: 'center' }}>
							<p>Please enter how many new {_.lowerCase(this.PLANS[this.state.selectedPlanid])} </p>
						</Modal.Content>
						<Modal.Content style={{ display: 'flex' }}>
							<Modal.Content style={{ width: 250, textAlign: 'center' }}>
								<Dropdown
									options={this.state.options}
									placeholder="Choose Quantity"
									selection
									value={quantityUpdate}
									defaultValue={1}
									onAddItem={this.handleAddition}
									onChange={this.handleChangeUpdate}
								/>
							</Modal.Content>
							<Modal.Content style={{ width: 250, textAlign: 'center', margin: 'auto' }}>
								<p>The total price to be added is: {this.state.quantityUpdate * this.state.amountPrice}$</p>
							</Modal.Content>
						</Modal.Content>
						<Modal.Actions style={{ textAlign: 'center' }}>
							<Stack spacing={2} direction="row">
								<Button color="error" variant="contained" startIcon={<CloseIcon />} onClick={this.closeModal}>
									Back
								</Button>
								<Button color="success" variant="contained" startIcon={<CheckIcon />} onClick={this.openPreviewModal({ add: true })}>
									Proceed
								</Button>
							</Stack>
						</Modal.Actions>
					</Modal>
					{/*cancel modal*/}
					<Modal open={this.state.unsubscribe} onClose={this.closeModal} style={{ maxWidth: '500px' }}>
						<Header icon="trash" content="Unsubscribe" />
						<Modal.Content>
							<p>Are you sure you want to unsubscribe?</p>
						</Modal.Content>
						<Modal.Actions>
							<Stack spacing={2} direction="row">
								<Button color="error" variant="contained" startIcon={<CloseIcon />} onClick={this.closeOne}>
									No
								</Button>
								<Button
									color="success"
									variant="contained"
									startIcon={<CheckIcon />}
									onClick={this.clickUnSubs({
										subscription_id: this.state.selectedSubs,
										plan_id: this.state.selectedPlanId,
										quantity: this.state.selectedQuantity,
									})}
								>
									Yes
								</Button>
							</Stack>
						</Modal.Actions>
					</Modal>
					{/*cancel trial modal*/}
					<Modal open={this.state.unsubscribeTrial} onClose={this.closeModal} style={{ maxWidth: '500px' }}>
						<Header icon="trash" content="Unsubscribe" />
						<Modal.Content>
							<p>Are you sure you want to unsubscribe from trial?</p>
							<p>You cannot subscribe to the trial version again.</p>
						</Modal.Content>
						<Modal.Actions>
							<Stack spacing={2} direction="row">
								<Button color="error" variant="contained" startIcon={<CloseIcon />} onClick={this.closeOne}>
									No
								</Button>
								<Button
									color="success"
									variant="contained"
									startIcon={<CheckIcon />}
									onClick={this.deleteTrial()}
									loading={this.state.trialButtonLoading}
								>
									Yes
								</Button>
							</Stack>
						</Modal.Actions>
					</Modal>
					{/* trial success modal */}
					<Modal open={this.state.trialSuccess} onClose={this.closeTrialModal}>
						<Header icon="check" content="Subscription Success" />
						<Modal.Content>
							<p>Your free trial subscription start successfully.</p>
							<p>{this.state.trialPlan === 'api' ? 'You can add phones now.' : 'You can add phones or agents now.'}</p>
						</Modal.Content>
						<Modal.Actions style={{ textAlign: 'center' }}>
							<Stack spacing={2} direction="row">
								<Link to="/phones">
									<Button color="success" variant="contained" startIcon={<PhoneIphoneIcon />}>
										Connect Phones
									</Button>
								</Link>
								<Button color="error" variant="contained" startIcon={<CloseIcon />} onClick={this.closeTrialModal}>
									Close
								</Button>
							</Stack>
						</Modal.Actions>
					</Modal>
					{/*wait*/}
					<Modal open={this.state.buyWait} onClose={this.closeWaitModal()} style={{ maxWidth: '500px' }}>
						<Header icon="setting" content="Upgrading" />
						<Modal.Content>
							<p>Maytapi is Upgrading now.</p>
							<p>Please, try later.</p>
						</Modal.Content>
						<Modal.Actions style={{ textAlign: 'center' }}>
							<Button color="error" variant="contained" startIcon={<CloseIcon />} onClick={this.closeWaitModal()}>
								Close
							</Button>
						</Modal.Actions>
					</Modal>
					{/*change base subs  */}
					<Modal open={this.state.planChangeModal} onClose={this.closeModal} style={{ maxWidth: '500px' }}>
						<Header icon="exchange" content="Change Your Subscription" />
						<Modal.Content>
							<div style={{ display: 'flex' }}>
								{this.state.previewdata && this.state.previewdata.immediate_payment ? (
									<div style={{ margin: 'auto' }}>
										<h3>Immediate Payment:</h3>
										<p>Amount: {this.state.previewdata && this.state.previewdata.immediate_payment.amount + ' $'}</p>
										<p>Date: {this.state.previewdata && this.state.previewdata.immediate_payment.date} </p>
									</div>
								) : null}
								<div style={{ margin: 'auto' }}>
									<h3>Next Payment:</h3>
									<p>Amount: {this.state.previewdata && this.state.previewdata.next_payment.amount + ' $'}</p>
									<p>Date: {this.state.previewdata && this.state.previewdata.next_payment.date}</p>
								</div>
							</div>
						</Modal.Content>
						<Modal.Actions style={{ textAlign: 'left' }}>
							<div style={{ display: 'flex' }}>
								<h3 style={{ marginBottom: 'auto', marginTop: 'auto' }}>Are you sure change to {this.PLANS[this.state.selectedChange]} </h3>
								<Stack spacing={2} direction="row">
									<Button
										color="success"
										variant="contained"
										startIcon={<CheckIcon />}
										onClick={this.changePlanId(this.state.selectedChange, this.state.selectedSubcriptionId, this.props.product.id)}
									>
										Yes
									</Button>
									<Button color="error" variant="contained" startIcon={<CloseIcon />} onClick={this.closeModal}>
										Close
									</Button>
								</Stack>
							</div>
						</Modal.Actions>
					</Modal>
					{/*update preview subs  */}
					<Modal open={this.state.previewModal} onClose={this.closeModal} style={{ maxWidth: '700px' }}>
						<Header icon="exchange" content="Update Subscription" />
						<Modal.Content>
							<div style={{ display: 'flex' }}>
								{this.state.previewdata && this.state.previewdata.immediate_payment ? (
									<div style={{ margin: 'auto' }}>
										<h3>Immediate Payment:</h3>
										<p>Amount: {this.state.previewdata && this.state.previewdata.immediate_payment.amount + ' $'}</p>
										<p>Date: {this.state.previewdata && this.state.previewdata.immediate_payment.date} </p>
									</div>
								) : null}
								<div style={{ margin: 'auto' }}>
									<h3>Next Payment:</h3>
									<p>Amount: {this.state.previewdata && this.state.previewdata.next_payment.amount + ' $'}</p>
									<p>Date: {this.state.previewdata && this.state.previewdata.next_payment.date}</p>
								</div>
							</div>
							{this.state.previewdata && !this.state.previewdata.immediate_payment ? (
								<div style={{ marginTop: '20px' }}>
									<h3>Select Phones</h3>
									{this.state.quantityUpdate > this.state.selectedOldQuantity ? (
										<p>Select phones to activate immediately</p>
									) : (
										<p>Select phones to disabled at the end of billing period</p>
									)}

									<Dropdown
										placeholder="Select Phones"
										fluid
										multiple
										selection
										options={this.state.phoneOptions}
										value={this.state.selectedPhoneIds}
										onChange={this.handlePhoneSelection}
									/>

									<p style={{ marginTop: '10px', color: '#666' }}>
										{`Select ${Math.abs(this.state.quantityUpdate - this.state.selectedOldQuantity)} phone${
											Math.abs(this.state.quantityUpdate - this.state.selectedOldQuantity) !== 1 ? 's' : ''
										}`}
									</p>
								</div>
							) : null}
						</Modal.Content>
						<Modal.Actions style={{ textAlign: 'left' }}>
							<div>
								<h3 style={{ marginBottom: 'auto', marginTop: 'auto' }}>
									Are you sure update your {this.PLANS[this.state.selectedPlanid]} subscription.
								</h3>
								<Stack spacing={2} direction="row" style={{ marginTop: '10px' }}>
									<Button
										color="success"
										variant="contained"
										startIcon={<CheckIcon />}
										disabled={
											// Artırma durumunda disabled false olacak
											!(this.state.previewdata && this.state.previewdata.immediate_payment) &&
											// Düşürmede telefon seçimi kontrolü
											this.state.selectedPhoneIds &&
											this.state.selectedPhoneIds.length !== this.state.selectedOldQuantity - this.state.quantityUpdate
										}
										onClick={this.updateAfterAmuntEntered({
											subscription_id: this.state.selectedSubs,
											user_id: this.state.selectedUserid,
											plan_id: this.state.selectedPlanid,
											quantity: this.state.quantityUpdate,
											old_quantity: this.state.selectedOldQuantity,
										})}
									>
										Yes
									</Button>
									<Button color="error" variant="contained" startIcon={<CloseIcon />} onClick={this.closeModal}>
										Close
									</Button>
								</Stack>
							</div>
						</Modal.Actions>
					</Modal>
					{/*purchase Modal*/}
					<Modal open={this.state.purchaseModal} onClose={this.closeModal} style={{ maxWidth: '600px' }} history>
						<Header icon="exchange" content="Purchase" />
						<Modal.Content scrolling>
							<div>
								<div style={{ margin: 'auto', marginBottom: '10px' }}>
									<h3 style={{ marginBottom: '6px' }}>This package price is ${this.state.purchasePrice * this.state.quantityUpdate}</h3>
									<p>If you enter company informations, you don't pay TAX.</p>
									<Button
										color="primary"
										variant="contained"
										onClick={this.checkoutHandler(this.state.quantityUpdate, this.state.selectedPlanId, false)}
									>
										I don't have a company.
									</Button>
								</div>
								<Divider />
								<Form onSubmit={this.checkoutHandler(this.state.quantityUpdate, this.state.selectedPlanId, true)} style={{ marginTop: '15px' }}>
									<Form.Input
										className="flex-container"
										label="Vat Number"
										placeholder="Enter VAT Number"
										required
										name="vatNumber"
										value={vatNumber}
										onChange={this.handleFormChange}
									></Form.Input>
									<Form.Input
										className="flex-container"
										label="Company Name"
										required
										name="companyName"
										placeholder="Enter Company Name"
										value={companyName}
										onChange={this.handleFormChange}
									></Form.Input>
									<Form.Input
										className="flex-container"
										label="Street"
										required
										name="companyStreet"
										value={companyStreet}
										placeholder="Enter Street"
										onChange={this.handleFormChange}
									></Form.Input>
									<Form.Input
										className="flex-container"
										label="City"
										required
										value={companyCity}
										name="companyCity"
										placeholder="Enter City"
										onChange={this.handleFormChange}
									></Form.Input>
									<Form.Input
										className="flex-container"
										label="State"
										value={companyState}
										name="companyState"
										placeholder="Enter State"
										onChange={this.handleFormChange}
									></Form.Input>
									<Form.Dropdown
										className="flex-container"
										label="Country"
										placeholder="Select Country"
										search
										required
										autoComplete="off"
										fluid
										name="companyCountry"
										value={companyCountry}
										options={Countries}
										selection
										onChange={this.handleFormChange}
									></Form.Dropdown>
									<Form.Input
										className="flex-container"
										label="Postcode (**)"
										placeholder="Enter Post Code"
										value={companyPostCode}
										required={_.includes(['AU', 'CA', 'DE', 'ES', 'FR', 'GB', 'IN', 'IT', 'NL', 'US'], this.state.country)}
										name="companyPostCode"
										onChange={this.handleFormChange}
									></Form.Input>
									<Form.Input className="flex-container" label="Phone number">
										<IntlTelInput
											style={{ width: '100%' }}
											preferredCountries={['tr']}
											containerClassName="intl-tel-input purchase-phone"
											inputClassName="form-control-phone-number"
											name={'purschaseTextModal'}
											value={purschaseTextModal}
											onPhoneNumberChange={(status, value, countryData, number, id) => {
												this.handleChangePurschaseModalPhone(value, status, countryData, number, id);
											}}
										/>
									</Form.Input>
									<Form.Group>
										<Form.Button style={{ marginLeft: 'auto' }} positive type="submit">
											<Icon name="checkmark" /> Next
										</Form.Button>
										<Form.Button color="red" onClick={this.closeModal}>
											<Icon name="x" /> Close
										</Form.Button>
									</Form.Group>
								</Form>
								<span>(**) Selected country has (*), postcode is required.</span>
							</div>
						</Modal.Content>
					</Modal>
					{/*Payment History*/}
					<Modal open={this.state.historyModal} onClose={this.closeModal} style={{ maxWidth: '500px' }}>
						<Header icon="dollar" content="Payment History" />
						{(() => {
							const lastPaid = _.find(_.orderBy(this.state.paymentHistory, 'id', 'desc'), { is_paid: 1 });
							return lastPaid ? (
								<Modal.Content style={{ paddingBottom: '0', background: '#f8f9fa', borderBottom: '1px solid #dee2e6' }}>
									<p style={{ margin: 0, fontSize: '13px', color: '#6c757d', paddingBottom: '10px' }}>
										To view the card used for this payment — including the card brand and last 4 digits — please check your latest invoice.{' '}
										<a href={lastPaid.receipt_url} target="_blank" rel="noopener noreferrer">
											View latest invoice
										</a>
									</p>
								</Modal.Content>
							) : null;
						})()}
						<Modal.Content>
							<h4>Next Payment</h4>
							{_.map(_.filter(this.state.paymentHistory, { is_paid: 0 }), function (it) {
								return (
									<a
										href={it.is_paid ? it.receipt_url : null}
										target="_blank"
										rel="noopener noreferrer"
										key={it.id}
										style={{
											display: 'flex',
											color: '#646464',
											padding: '14px',
											flex: ' 0 0 auto',
											textDecoration: 'none',
											border: '1px solid rgb(221, 221, 221)',
											fontSize: '600',
										}}
									>
										<div style={{ width: '70%' }}>
											<div style={{ fontWeight: '600' }}>{'OrderCode: ' + it.id}</div>
											<div style={{ fontWeight: '600' }}>
												{'Next Bill Date: ' + moment(it.payout_date, 'YYYY-MM-DD').format('MMM DD, YYYY')}
											</div>
										</div>
										<div>
											<div style={{ fontWeight: '600' }}>{'$' + it.amount}</div>
										</div>
									</a>
								);
							})}
						</Modal.Content>
						<Modal.Content style={{ paddingTop: '0', paddingBottom: '0' }}>
							<h4>Past Payments</h4>
						</Modal.Content>
						<Modal.Content scrolling>
							<div style={{ borderTop: '1px solid rgb(221, 221, 221)', borderRadius: '4px', display: 'flex' }}></div>
							{_.map(_.filter(this.state.paymentHistory, { is_paid: 1 }), function (it) {
								return (
									<a
										href={it.is_paid ? it.receipt_url : null}
										target="_blank"
										rel="noopener noreferrer"
										key={it.id}
										style={{
											display: 'flex',
											color: '#646464',
											padding: '14px',
											flex: ' 0 0 auto',
											textDecoration: 'none',
											border: '1px solid rgb(221, 221, 221)',
											borderTop: 'none',
											fontSize: '600',
										}}
									>
										<div style={{ width: '70%' }}>
											<div style={{ fontWeight: '600' }}>{'Order Code: ' + it.id}</div>
											<div style={{ fontWeight: '600' }}>{'Date: ' + moment(it.payout_date, 'YYYY-MM-DD').format('MMM DD, YYYY')}</div>
										</div>
										<div>
											<div style={{ fontWeight: '600' }}>{'$' + it.amount}</div>
											<div style={{ textDecoration: 'underline', color: 'black', fontWeight: '400' }}>Show Receipt</div>
										</div>
									</a>
								);
							})}
						</Modal.Content>
					</Modal>
					{/*Change Trial*/}
					<Modal open={this.state.trialChangeModal} onClose={this.closeModal} style={{ maxWidth: '500px' }}>
						<Header icon="exchange" content="Change Your Trial Type" />
						<Modal.Content>
							<p>Your subscription will transform to API trial.</p>
						</Modal.Content>
						<Modal.Actions style={{ textAlign: 'left' }}>
							<div style={{ display: 'flex' }}>
								<h3 style={{ marginBottom: 'auto', marginTop: 'auto' }}>Are you sure change to trial type.</h3>
								<Stack spacing={2} direction="row">
									<Button
										color="success"
										loading={this.state.changeTrialButtonLoading}
										variant="contained"
										startIcon={<CheckIcon />}
										onClick={this.changeTrial({ plan: this.state.trialChangePlan })}
									>
										Yes
									</Button>
									<Button color="error" variant="contained" startIcon={<CloseIcon />} onClick={this.closeModal}>
										No
									</Button>
								</Stack>
							</div>
						</Modal.Actions>
					</Modal>
					{/*Help Modal */}
					<Modal open={this.state.helpModal} onClose={this.closeModal} style={{ maxWidth: '500px' }}>
						<Header icon="frown outline" content="We're sad to see you go!" style={{ border: 'none', color: '#464646' }} />
						<Modal.Content style={{ paddingTop: '0' }}>
							<p style={{ fontSize: '16px', color: '#7e7e7e' }}>
								Before you cancel, please let us know the reason you're leaving. Every bit of feedback helps!
							</p>
							<FormControl>
								<RadioGroup
									aria-labelledby="demo-radio-buttons-group-label"
									name="radio-buttons-group"
									value={this.state.feedbackOption}
									onChange={this.openTextInFeedback}
								>
									{_.map(Questions, (e) => {
										return <FormControlLabel className="radio-mytp" value={e.state} control={<Radio color="success" />} label={e.title} />;
									})}
								</RadioGroup>
							</FormControl>

							{_.find(Questions, (e) => {
								if (e.state === this.state.feedbackOption) {
									return e.textbox;
								}
							}) ? (
								<div>
									<TextField
										id="standard-multiline-static"
										label={this.state.feedbackTitle}
										multiline
										fullWidth
										rows={4}
										name="feedbackText"
										value={this.state.feedbackText}
										onChange={this.handleChangeFeedback}
										variant="filled"
									/>
									<p style={{ color: 'red', marginTop: '5px', marginBottom: '5px' }}>
										Explain your reason for cancellation in at least 20 characters
									</p>
								</div>
							) : null}

							<IntlTelInput
								name={'phoneTextModal'}
								value={phoneTextModal}
								preferredCountries={['tr']}
								containerClassName="intl-tel-input"
								inputClassName="form-control"
								onPhoneNumberChange={(status, value, countryData, number, id) => {
									this.handleChangePhone(value, status, countryData, number, id);
								}}
							/>
						</Modal.Content>
						<Modal.Actions className="padd-rem">
							<div style={{ display: 'flex', alignItems: 'center' }}>
								<Stack spacing={2} direction="row" sx={{ display: 'contents' }}>
									<span
										style={{ fontSize: '14px', color: '#0080ff', cursor: 'pointer' }}
										loading={true}
										color="success"
										variant="contained"
										disabled={this.state.disableSubCancelButton}
										startIcon={this.state.loadSubButton ? <CircularProgress size={20} /> : <CloseIcon />}
										onClick={this.closeModal}
									>
										Nevermind, I don't want to cancel
									</span>
									<Button
										sx={{ fontSize: '11px' }}
										className="button-auto"
										color="error"
										loading={this.state.changeTrialButtonLoading}
										variant="contained"
										disabled={this.state.feedbackText.length < 20}
										startIcon={this.state.loadSubButton ? <CircularProgress size={20} /> : <SentimentVeryDissatisfiedIcon />}
										onClick={this.sendFeedback()}
									>
										Unsubscribe
									</Button>
								</Stack>
							</div>
						</Modal.Actions>
					</Modal>
					{/*DisablePhones Modal*/}
					<Modal open={this.state.disabledPhonesModal} onClose={() => this.setState({ disabledPhonesModal: false })} style={{ maxWidth: '500px' }}>
						<Header icon="info" content="Disabled Phones Detected" />
						<Modal.Content>
							<p>
								Your operation was successful. Note: You have {this.state.disabledPhonesCount} disabled phone
								{this.state.disabledPhonesCount !== 1 ? 's' : ''}. You can reactivate {this.state.disabledPhonesCount !== 1 ? 'them' : 'it'}{' '}
								instead of adding new phone numbers.
							</p>
						</Modal.Content>
						<Modal.Actions style={{ textAlign: 'center' }}>
							<Stack spacing={2} direction="row">
								<Button color="primary" variant="contained" onClick={() => (window.location.href = '/')}>
									Manage Phones
								</Button>
								<Button
									color="error"
									variant="contained"
									startIcon={<CloseIcon />}
									onClick={() => this.setState({ disabledPhonesModal: false })}
								>
									Close
								</Button>
							</Stack>
						</Modal.Actions>
					</Modal>

					{/*Restart Subscription Modal*/}
					<Modal open={this.state.restartModal} onClose={this.closeModal} style={{ maxWidth: '500px' }}>
						<Header icon="play" content="Restart Subscription" />
						<Modal.Content>
							<div style={{ textAlign: 'center' }}>
								<h3>Restart {this.state.restartSubscriptionData?.subscription_name}</h3>
								<p>Your subscription will be reactivated and billing will resume immediately.</p>

								<div
									style={{
										background: '#f8f9fa',
										padding: '15px',
										borderRadius: '8px',
										margin: '15px 0',
										border: '1px solid #e9ecef',
									}}
								>
									<h4 style={{ margin: '0 0 10px 0', color: '#495057' }}>Payment Details</h4>
									<p style={{ margin: '5px 0', fontSize: '16px' }}>
										<strong>Amount: ${this.state.restartSubscriptionData?.next_payment_amount || '0.00'}</strong>
									</p>
									<p style={{ margin: '5px 0', color: '#6c757d', fontSize: '14px' }}>This amount will be charged immediately upon restart.</p>
								</div>

								<p style={{ color: '#6c757d', fontSize: '14px' }}>A new billing cycle will begin from today's date.</p>
							</div>
						</Modal.Content>
						<Modal.Actions style={{ textAlign: 'center' }}>
							<Stack spacing={2} direction="row">
								<Button
									color="error"
									variant="contained"
									startIcon={<CloseIcon />}
									onClick={this.closeModal}
									disabled={this.state.loadSubButton}
								>
									Cancel
								</Button>
								<Button
									color="success"
									variant="contained"
									startIcon={this.state.loadSubButton ? <CircularProgress size={20} /> : <CheckIcon />}
									onClick={this.reActiveSub({
										subscription_id: this.state.restartSubscriptionData?.subscription_id,
									})}
									disabled={this.state.loadSubButton}
								>
									{this.state.loadSubButton ? 'Processing...' : 'Confirm Restart'}
								</Button>
							</Stack>
						</Modal.Actions>
					</Modal>
				</Box>
			</Page>
		);
	}
}
const stateToProps = (state) => ({
	access: state.access,
	location: state.router.location,
	product: state.product.maytapi,
	user: state.access.user.loggedUserObj,
});

export default connect(stateToProps)(Payment);
